import { createContext, useContext, useState, useEffect } from "react";

const dict = {
  fr: {
    "vault.cta": "Vérification Coffre",
    "vault.running": "Vérification…",
    "vault.done": "Vérification Coffre effectuée —",
    "vault.error": "Vérification impossible",
    "vault.panel.title": "Vérification Coffre",
    "vault.score": "Score requalifié",
    "vault.labels": "Labels du coffre pris en compte",
    "vault.status.covered": "Couvert",
    "vault.status.partial": "Partiel",
    "vault.status.gap": "Non couvert",
    "vault.gap.title": "Écarts (GAP) et préconisations",
    "vault.history": "Historique des versions",
    "vault.verified.badge": "Vérifié coffre",
    "footer.labels.dir": "Annuaire des labels UE-27",
    "authority.cta": "Organismes de vérification",
    "authority.title": "Compte rendu pour une autorité de contrôle",
    "authority.intro": "Choisissez le pays et l'organisme de contrôle : EmpCo génère un compte rendu PDF dans la langue de l'autorité, avec l'historique complet des scores et horodatages, l'apport de vos certifications et les écarts restants.",
    "authority.country": "Pays", "authority.country.ph": "Choisir un pays",
    "authority.eu": "Union européenne (niveau UE)",
    "authority.body": "Organisme de contrôle", "authority.body.ph": "Choisir un organisme",
    "authority.site": "Site officiel",
    "authority.lang": "Langue du compte rendu",
    "authority.lang.hint": "Pré-remplie selon le pays de l'autorité. Les noms de labels restent dans leur langue d'origine.",
    "authority.generate": "Générer le compte rendu",
    "authority.generating": "Génération…",
    "authority.generated": "Compte rendu généré",
    "authority.error": "Génération impossible",
    "nav.pricing": "Tarifs",
    "nav.method": "Méthode",
    "nav.legal": "Loi",
    "nav.login": "Se connecter",
    "nav.dashboard": "Tableau de bord",
    "nav.logout": "Déconnexion",
    "nav.guides": "Guides",
    "nav.contact": "Contact",
    "contact.eyebrow": "Contact",
    "contact.title": "Parlons de votre conformité",
    "contact.intro": "Une question, une démo ou un besoin sur mesure ? Écrivez-nous et proposez un créneau : notre équipe commerciale vous répond sous 24 h ouvrées.",
    "contact.seo.title": "Contact — EmpCo",
    "contact.seo.desc": "Contactez l'équipe EmpCo pour une démo, une question sur la directive UE 2024/825 ou un rendez-vous commercial. Réponse sous 24 h.",
    "contact.f.first_name": "Prénom",
    "contact.f.last_name": "Nom",
    "contact.f.email": "Email",
    "contact.f.phone": "Téléphone",
    "contact.f.company": "Nom de l'entreprise",
    "contact.f.message": "Votre message (optionnel)",
    "contact.slots.title": "Prendre rendez-vous",
    "contact.slots.desc": "Choisissez un jour ouvré et une heure — nous vous confirmerons le créneau par email.",
    "contact.slots.hours": "Heure souhaitée",
    "contact.slots.chosen": "Créneau retenu",
    "contact.submit": "Envoyer",
    "contact.sending": "Envoi…",
    "contact.success": "Message envoyé — nous revenons vers vous rapidement.",
    "contact.success.title": "Merci pour votre message",
    "contact.success.desc": "Notre équipe commerciale vous répondra sous 24 heures ouvrées à l'adresse email indiquée.",
    "contact.err.required": "Prénom, nom et email sont obligatoires.",
    "contact.err.generic": "Erreur d'envoi, réessayez.",
    "pay.redirect": "Redirection vers le paiement sécurisé…",
    "pay.secure": "Paiement sécurisé Stripe · TVA calculée automatiquement",
    "pay.checking": "Vérification du paiement…",
    "pay.checking.sub": "Nous confirmons votre paiement auprès de Stripe. Cela prend quelques secondes.",
    "pay.processing": "Paiement confirmé — analyse en cours",
    "pay.sepa_pending": "Prélèvement SEPA initié",
    "pay.sepa_pending.sub": "Votre mandat a été signé. Le débit sera confirmé sous 3 à 5 jours ouvrés selon les règles interbancaires SEPA. Votre abonnement s'activera automatiquement dès validation. Vous pouvez fermer cette page.",
    "pay.processing.sub": "Crawl du site et qualification IA de chaque allégation. Comptez 30 à 90 secondes, vous serez redirigé automatiquement.",
    "pay.done": "C'est prêt !",
    "pay.done.sub": "Merci. Redirection vers votre espace…",
    "pay.error": "Un problème est survenu",
    "pay.error.sub": "Le paiement n'a pas pu être confirmé ou le scan a échoué. Contactez contact@empco-compliance.eu avec la référence ci-dessous.",
    "pay.timeout": "Toujours en cours",
    "pay.timeout.sub": "Le traitement prend plus de temps que prévu. Retrouvez votre rapport dans le tableau de bord d'ici quelques minutes.",
    "pay.cancel": "Paiement annulé",
    "pay.cancel.sub": "Aucun montant n'a été débité. Vous pouvez relancer le paiement à tout moment.",
    "fullscan.included": "Inclus dans votre abonnement Surveillance (1 opération de quota par scan).",
    "fullscan.paid": "Scan site internet 20 € HT — paiement sécurisé Stripe, facture générée automatiquement.",
    "score.title": "Score de conformité",
    "score.hint": "100 = aucune allégation à risque. −15 par allégation rouge, −5 par orange.",
    "badge.title": "Badge partageable",
    "badge.hint": "Affichez votre score sur votre site ou vos supports. Le badge pointe vers une page publique de vérification.",
    "badge.copy": "Copier le code",
    "badge.copied": "Code d'intégration copié",
    "badge.public": "Voir la page publique du badge →",
    "badge.notfound": "Badge introuvable.",
    "badge.page.eyebrow": "Score de conformité vérifié par EmpCo",
    "badge.page.scanned": "Analysé le",
    "badge.page.verified": "Scan site internet avec qualification IA",
    "badge.page.free": "Scan gratuit — pré-filtre lexical",
    "badge.page.disclaimer": "Ce score est un indicateur d'aide à la conformité fondé sur l'analyse des pages publiques à la date indiquée. Il ne constitue pas un avis juridique.",
    "guides.eyebrow": "Guides conformité",
    "guides.title": "Comprendre et appliquer la directive UE 2024/825",
    "guides.sub": "Articles pratiques pour les équipes marketing, e-commerce et conformité : définitions, preuves, reformulations, sanctions.",
    "guides.read": "Lire le guide",
    "guides.related": "À lire aussi",
    "guides.cta.sub": "Scannez votre site gratuitement et découvrez votre score de conformité en 2 minutes.",
    "nav.reports": "Rapports hebdo",
    "nav.admin": "Admin corpus",
    "scan.ratelimit": "Trop de scans gratuits depuis votre adresse. Réessayez dans une heure ou créez un compte.",
    "reports.eyebrow": "Surveillance",
    "reports.title": "Rapports hebdomadaires",
    "reports.generate": "Générer maintenant",
    "reports.generated": "Rapport généré",
    "reports.email.pending": "Envoi e-mail en attente : aucun fournisseur (Resend / SendGrid) configuré. Les rapports sont générés et archivés ici ; l'envoi démarrera dès qu'une clé API sera ajoutée.",
    "nav.compare": "Comparateur",
    "nav.subscriptions": "Abonnements",
    "nav.subscriptions.eyebrow": "Espace client",
    "subscriptions.intro": "Choisissez la formule adaptée à votre besoin. Toutes nos offres incluent la génération automatique de factures et le calcul de la TVA.",
    "subscriptions.active": "Vous êtes abonné à Surveillance. Merci ! Gérez votre facturation dans le menu \"Facturation\".",
    "subscriptions.cta.sub": "Activation abonnement — 200 € HT /mois",
    "subscriptions.cta.scan": "Paiement pour un scan — 20 € HT",
    "subscriptions.payment_methods": "Paiement par carte bancaire ou par prélèvement SEPA (virement bancaire) — factures et TVA automatiques.",
    "billing.intro": "Retrouvez ici l'ensemble de vos factures. Chacune est téléchargeable en PDF avec les mentions légales et la TVA.",
    "nav.how": "Comment ça marche ?",
    "compare.title": "Comparez-vous à un concurrent",
    "compare.sub": "Scannez votre site et celui d'un concurrent en une seule fois. Vous voyez où vous êtes en avance… et où il faut agir.",
    "compare.mine": "Votre site",
    "compare.theirs": "Concurrent",
    "compare.cta": "Lancer la comparaison",
    "compare.loading": "Analyse en cours…",
    "compare.err.miss": "Renseignez les deux URL",
    "compare.err.fail": "Comparaison impossible. Vérifiez les URL.",
    "compare.verdict": "Verdict",
    "compare.you_lead": "Vous êtes devant de",
    "compare.they_lead": "Vous êtes en retard de",
    "compare.tie": "Match nul, à quelques allégations près.",
    "compare.deltas": "Écart par catégorie",
    "compare.category": "Catégorie",
    "compare.red": "rouges",
    "compare.orange": "oranges",
    "compare.note": "Δ positif = le concurrent a plus d'allégations à risque que vous sur cette catégorie.",
    "reports.email.ready": "Envoi e-mail actif via Resend. Vous recevez chaque rapport sur votre e-mail de compte.",
    "reports.email.sent": "E-mail envoyé",
    "reports.email.failed": "Envoi e-mail échoué",
    "reports.email.resend": "Renvoyer par e-mail",
    "reports.email.resent": "E-mail renvoyé",
    "trust.eyebrow": "Trust badge — Vérifié par EmpCo",
    "trust.grade": "Note",
    "trust.red": "Allégations rouges",
    "trust.orange": "Allégations orange",
    "trust.proofs": "Preuves déposées",
    "trust.categories": "Catégories analysées",
    "trust.share": "Partager cette page",
    "trust.copied": "Lien copié",
    "trust.cta": "Vérifier mon site avec EmpCo",
    "reports.trend": "Tendance du score (12 dernières semaines)",
    "reports.empty": "Aucun rapport. Les abonnés Surveillance reçoivent un rapport automatique chaque semaine ; vous pouvez en générer un maintenant.",
    "reports.item": "Rapport hebdo",
    "reports.new": "nouvelles",
    "reports.sent": "envoyé",
    "reports.pending": "e-mail en attente",
    "reports.new_claims": "Nouvelles allégations",
    "reports.scans": "Scans de la semaine",
    "reports.expiring": "Preuves expirant sous 30 j",
    "reports.first": "Premier rapport — pas encore de comparaison.",
    "reports.vs": "vs semaine précédente",
    "nav.fullscan": "Scan site internet",
    "nav.imagescan": "Analyser une image",
    "img.eyebrow": "Analyse d'image",
    "img.title": "Analysez un packaging, une photo produit ou une affiche",
    "img.sub": "Déposez une image : notre IA lit le texte marketing, isole chaque allégation environnementale et la qualifie au regard de la directive UE 2024/825.",
    "img.cta": "Analyser l'image",
    "img.included": "Inclus dans Surveillance — 1 opération de quota par image.",
    "img.paid": "20 € HT à l'unité — paiement sécurisé Stripe, facture automatique.",
    "img.note": "L'image est optimisée dans votre navigateur avant l'envoi. Formats PNG, JPG, WEBP — 1 image à la fois.",
    "img.analyzing": "Analyse IA en cours…",
    "img.drop.hint": "Packaging, photo de produit ou affiche — ou cliquez pour parcourir.",
    "img.landing.eyebrow": "Nouveau · Analyse d'image",
    "img.landing.h": "Vos packagings et affiches passent aussi au contrôle",
    "img.landing.sub": "Le greenwashing ne vit pas que sur votre site. Déposez un packaging, une étiquette ou une affiche : EmpCo lit le texte, détecte les allégations à risque et vous donne un score en 2 minutes.",
    "img.landing.b1": "OCR + IA : lecture du texte marketing directement sur l'image",
    "img.landing.b2": "Mêmes verdicts et score que le scan de site",
    "img.landing.b3": "Idéal pour valider un visuel avant impression ou mise en ligne",
    "img.landing.included": "Inclus dans les offres 20 € (à l'unité) et 200 €/mois (Surveillance).",
    "img.landing.cta": "Analyser mon image gratuitement",
    "img.landing.hint": "Démo gratuite · aperçu flouté · aucune inscription requise",
    "nav.docscan": "Analyser un document",
    "tab.site": "Mon site",
    "tab.image": "Image / packaging",
    "tab.document": "Document",
    "doc.eyebrow": "Analyse de document",
    "doc.title": "Analysez un cahier des charges, une fiche produit…",
    "doc.sub": "Déposez un document (PDF, DOCX, TXT) : notre IA en extrait le texte, isole les allégations environnementales et les qualifie au regard de la directive UE 2024/825.",
    "doc.cta": "Analyser le document",
    "doc.included": "Inclus dans Surveillance — 1 opération de quota par document.",
    "doc.paid": "20 € HT à l'unité — paiement sécurisé Stripe, facture automatique.",
    "doc.note": "PDF, DOCX ou TXT — 1 document à la fois, 10 Mo max. Le texte est extrait puis analysé, aucune donnée revendue.",
    "doc.analyzing": "Analyse IA en cours…",
    "doc.drop.hint": "Cahier des charges, fiche produit, brochure… ou cliquez pour parcourir.",
    "doc.landing.cta": "Analyser mon document gratuitement",
    "modes.eyebrow": "3 façons de scanner",
    "modes.h": "Site, packaging ou document : tout passe au contrôle",
    "modes.sub": "Le greenwashing ne vit pas que sur votre site web. EmpCo analyse aussi vos visuels et vos documents avec le même moteur juridique.",
    "modes.site.t": "Votre site web",
    "modes.site.d": "Explorez jusqu'à 200 pages : allégations, mentions, pages produits — score et dossier en 2 minutes.",
    "modes.image.t": "Image produit / packaging",
    "modes.image.d": "Glissez un packaging, une étiquette ou une affiche : l'IA lit le texte marketing et détecte les allégations à risque.",
    "modes.document.t": "Document",
    "modes.document.d": "Cahier des charges, fiche produit, brochure (PDF/DOCX/TXT) : vérifiez vos allégations avant diffusion.",
    "modes.foot": "2 scans gratuits, sans carte. Au-delà : 20 € à l'unité ou 200 €/mois en surveillance continue.",
    "limit.badge": "Limite atteinte",
    "limit.title": "Vous avez utilisé vos 2 scans gratuits",
    "limit.sub": "Merci d'avoir testé EmpCo ! Pour continuer à analyser vos sites, packagings et documents, choisissez l'offre qui vous convient.",
    "limit.cta.register": "Créer mon compte",
    "limit.foot": "Sans engagement · Paiement sécurisé Stripe · Données hébergées en UE",
    "cgv.accept.pre": "J'ai lu et j'accepte les",
    "cgv.accept.link": "conditions générales de vente et d'utilisation",
    "cgv.required": "Vous devez accepter les CGV pour créer votre compte.",
    "nav.sites": "Sites",
    "nav.proofs": "Coffre preuves",
    "nav.alerts": "Alertes",
    "nav.journal": "Journal",
    "nav.workspace": "Espace client",
    "brand.baseline": "Vos allégations environnementales, à l'épreuve de la loi.",
    "brand.baseline.l1": "Vos allégations environnementales,",
    "brand.baseline.l2": "à l'épreuve de la loi.",
    "hero.trust1": "Aucune carte requise",
    "hero.trust2": "Résultat en moins de 2 minutes",
    "hero.trust3": "Données hébergées en UE",
    "hero.card.eyebrow": "Scan en cours",
    "hero.card.pages": "Pages",
    "hero.alert.title": "Certificat COSMOS expire dans 27 jours",
    "kpi.1": "Entrée en application de la directive UE 2024/825",
    "kpi.2": "Dossier de contrôle prêt",
    "kpi.3": "Étapes de qualification, versionnées et traçables",
    "kpi.4": "Des allégations avec preuve, verdict et historique",
    "features.intro": "EmpCo scanne votre site, isole chaque allégation environnementale, la qualifie au regard de la directive UE 2024/825 et vous livre un registre vivant, prêt pour un contrôle DGCCRF.",
    "features.quote": "Toute allégation environnementale doit pouvoir être étayée par des éléments vérifiables — Directive (UE) 2024/825",
    "step.1t": "Crawl du site",
    "step.1d": "Exploration de vos pages publiques (≤ 200) : textes, balises, fiches produit, FAQ.",
    "step.2t": "Pré-filtre lexical",
    "step.2d": "Lexique juridique versionné FR/EN : « naturel », « neutre en carbone », « éco-responsable »…",
    "step.3t": "Qualification IA",
    "step.3d": "Chaque allégation est qualifiée (rouge / orange / verte), motivée et reformulée par un modèle Claude.",
    "step.4t": "Registre vivant",
    "step.4d": "Version, localisation, verdict et preuves attachées pour chaque allégation. Rien ne se perd.",
    "step.5t": "Alertes",
    "step.5d": "J-90 / J-30 / J-7 avant expiration d'une preuve.",
    "step.6t": "Dossier PDF",
    "step.6d": "Dossier de contrôle horodaté en 1 clic.",
    "pricing.popular": "Populaire",
    "legal.h": "La directive UE 2024/825 s'applique le 27 septembre 2026.",
    "legal.p1": "Publiée au Journal Officiel de l'Union le 6 mars 2024, elle interdit les allégations environnementales génériques, la neutralité carbone fondée sur la seule compensation, et impose que les labels de durabilité reposent sur un système de certification contrôlé par un tiers ou soient établis par une autorité publique.",
    "legal.p2": "Sanctions : amendes administratives (DGCCRF), retrait du produit, publication de la décision.",
    "legal.cta": "Préparer mon dossier",
    "auth.eyebrow": "Accès entreprise",
    "auth.register.intro": "Créez votre espace en 30 secondes. Seuls votre nom et votre e-mail sont requis — l'entreprise et le n° de TVA peuvent être complétés plus tard pour la facturation.",
    "auth.login.intro": "Reprenez la main sur votre registre vivant, vos alertes et votre dossier de contrôle.",
    "auth.b1": "Rapport complet avec reformulations conformes",
    "auth.b2": "Coffre à preuves et alertes d'expiration",
    "auth.b3": "Dossier de contrôle PDF horodaté",
    "auth.demo_note": "Aucune carte requise en démo · paiement simulé, facture réellement générée.",
    "footer.product": "Produit",
    "footer.legal": "Légal",
    "footer.directive": "Directive UE 2024/825 · Entrée en application le 27 septembre 2026",
    "footer.hosting": "Hébergé en UE · Facturation TVA UE",
    "hero.eyebrow": "Directive UE 2024/825 — application 27 septembre 2026",
    "hero.title": "Le registre vivant de vos allégations environnementales.",
    "hero.sub": "EmpCo scanne votre site, détecte chaque allégation environnementale et la qualifie au regard de la directive UE 2024/825. Registre vivant, preuves, alertes et dossier de contrôle prêt en 24 h. ⚠️ Non-conformité : amendes jusqu'à 4 % du CA annuel, retrait produit, publication de la décision.",
    "sticky.cta": "Testez gratuitement :",
    "refs.eyebrow": "Ils ont testé EmpCo*",
    "refs.disclaimer": "Références issues des adresses IP qui se sont connectées et qui ont effectué des essais sur notre site internet.",
    "hero.cta": "Scanner mon site gratuitement",
    "hero.cta2": "Voir la méthode",
    "hero.trust": "Utilisé par 40+ dirigeants FR/UK · Aucune carte requise pour le scan gratuit",
    "scan.title": "Scan gratuit",
    "scan.placeholder": "https://votre-site.com",
    "scan.button": "Lancer le scan",
    "scan.loading": "Analyse en cours (≤15 pages)…",
    "scan.error": "Impossible de scanner ce site. Vérifiez l'URL.",
    "report.title": "Rapport limité",
    "report.pages": "pages analysées",
    "report.red": "Red flags",
    "report.orange": "Orange flags",
    "report.blur": "Détails floutés. Débloquez le rapport complet + PDF horodaté pour 20 € HT.",
    "report.unlock": "Débloquer le rapport complet — 20 €",
    "report.exposure": "Exposition financière estimée",
    "features.h": "Ce que vous obtenez",
    "features.1t": "Détection déterministe",
    "features.1d": "Lexique juridique versionné + qualification LLM en batch. Aucune fausse promesse de « conformité automatique ».",
    "features.2t": "Registre vivant",
    "features.2d": "Chaque allégation a une version, une localisation, un verdict, et des preuves attachées. Rien ne se perd.",
    "features.3t": "Alertes J-90 / J-30 / J-7",
    "features.3d": "Vos certificats expirent, vos preuves aussi. On vous prévient avant que la DGCCRF ne le fasse.",
    "features.4t": "Dossier de contrôle 1-clic",
    "features.4d": "PDF horodaté avec allégations, versions, preuves, verdicts, extraits du corpus applicables à la date.",
    "pricing.h": "Nos offres, aucune option cachée.",
    "pricing.free": "Scan gratuit",
    "pricing.free.price": "0 €",
    "pricing.free.d": "≤ 15 pages · Pré-filtre lexical · Rapport limité + capture email",
    "pricing.paid": "Un scan complet aux choix",
    "billing.activate": "Activation abonnement — 200 € HT /mois",
    "billing.activate_sub": "Activation abonnement — 200 € HT /mois",
    "billing.pay_scan": "Paiement pour un scan — 20 € HT",
    "billing.payment_methods": "Paiement par carte bancaire ou prélèvement SEPA (virement) — factures & TVA automatiques.",
    "pricing.paid.price": "20 € HT",
    "pricing.paid.old": "40 €",
    "pricing.paid.d": "≤ 200 pages · Qualification IA · Reformulations · Score de risque · Analyse d'image (packaging/affiche) · PDF horodaté",
    "pricing.sub": "Scan Annuel + Surveillance",
    "pricing.sub.price": "200 € /mois HT",
    "pricing.sub.old": "400 € /mois HT",
    "pricing.sub.d": "Recrawl hebdo · Registre versionné · Coffre preuves · Alertes · Analyse d'image incluse · Dossier 1-clic · 3 users · Quota 100",
    "pricing.cta.free": "Lancer un scan",
    "pricing.cta.paid": "Commander — 20 € HT",
    "pricing.cta.sub": "S'abonner — 200 € /mois",
    "pricing.enterprise": "ETI / Grande entreprise",
    "pricing.enterprise.price": "Sur devis",
    "pricing.enterprise.d": "Volume illimité · Multi-marques et multi-sites · SLA dédié · Onboarding sur-mesure · Interlocuteur unique · Formations équipes",
    "pricing.cta.enterprise": "Nous appeler",
    "auth.register": "Créer un compte",
    "auth.login": "Se connecter",
    "auth.email": "Email professionnel",
    "auth.pwd": "Mot de passe",
    "auth.first": "Prénom",
    "auth.last": "Nom",
    "auth.company": "Entreprise (optionnel)",
    "auth.vat": "Code TVA (optionnel)",
    "auth.submit": "Continuer",
    "auth.submit_pay": "Créer mon compte et payer",
    "auth.plan.title": "Choisissez votre formule",
    "auth.plan.scan": "Scan complet",
    "auth.plan.scan.sub": "Analyse ≤ 200 pages · rapport PDF · TVA incluse.",
    "auth.plan.sub": "Abonnement Surveillance",
    "auth.plan.sub.sub": "Recrawl hebdo · alertes J-90/30/7 · dossier de contrôle · 100 opérations/mois.",
    "auth.plan.hint": "Paiement carte bancaire ou prélèvement SEPA. Vous êtes redirigé après la création du compte.",
    "auth.plan.required": "Merci de choisir une formule pour continuer.",
    "auth.have": "Déjà un compte ?",
    "auth.no": "Pas encore de compte ?",
    "dash.title": "Registre vivant",
    "dash.metrics.claims": "Allégations",
    "dash.metrics.proofs": "Preuves",
    "dash.metrics.alerts": "Alertes non lues",
    "dash.metrics.quota": "Quota",
    "dash.newsite": "Ajouter un site",
    "dash.verify": "Vérifier propriété",
    "dash.dossier": "Générer dossier de contrôle",
    "dash.no_site": "Ajoutez d'abord un site et vérifiez la propriété.",
    "verdicts.a_couvrir": "à couvrir",
    "verdicts.couvert": "couvert",
    "verdicts.expire": "expiré",
    "verdicts.non_conforme": "non conforme",
    "backoffice.title": "Facturation",
    "backoffice.orders": "Commandes",
    "backoffice.download": "Télécharger la facture",
    "backoffice.quota": "Quota surveillance",
    "backoffice.plan": "Formule active",
    "common.back": "Retour",
    "common.save": "Enregistrer",
    "common.cancel": "Annuler",
    "common.close": "Fermer",
    "common.add": "Ajouter",
    "common.download": "Télécharger",
    "footer.disclaimer": "EmpCo est un outil d'aide à la conformité. Ne constitue pas un avis juridique.",
    "cookie.banner.title": "Nous utilisons des cookies",
    "cookie.banner.body": "EmpCo utilise des cookies techniques strictement nécessaires (session, langue), et — avec votre accord — des cookies de mesure d'audience et de publicité (Google Analytics et Google Ads) pour améliorer notre service et mesurer nos campagnes. Vos choix sont conservés 13 mois et modifiables à tout moment depuis le footer.",
    "cookie.banner.learn": "En savoir plus",
    "cookie.btn.accept": "Tout accepter",
    "cookie.btn.refuse": "Tout refuser",
    "cookie.btn.customize": "Personnaliser",
    "cookie.btn.save": "Enregistrer mes choix",
    "cookie.panel.title": "Vos préférences cookies",
    "cookie.panel.sub": "Vous pouvez activer ou désactiver chaque catégorie",
    "cookie.panel.legal": "Conformément au Règlement (UE) 2016/679 (RGPD) et à la délibération CNIL n° 2020-091. Refuser n'a aucune conséquence sur votre navigation. Vos choix sont conservés 13 mois maximum.",
    "cookie.cat.necessary.title": "Cookies strictement nécessaires",
    "cookie.cat.necessary.desc": "Indispensables au fonctionnement du site (session, langue, sécurité). Exemptés de consentement (article 82 loi 1978).",
    "cookie.cat.always": "Toujours actifs",
    "cookie.cat.analytics.title": "Mesure d'audience — Google Analytics",
    "cookie.cat.analytics.desc": "Statistiques anonymisées de fréquentation pour améliorer notre service. IP anonymisée, aucune donnée revendue.",
    "cookie.cat.ads.title": "Publicité — Google Ads",
    "cookie.cat.ads.desc": "Mesure de la performance de nos campagnes publicitaires et affichage de publicités personnalisées sur d'autres sites.",
    "cookie.footer.link": "Gestion des cookies",
    "legal.directive_cta": "Directive UE",
  },
  en: {
    "vault.cta": "Vault verification",
    "vault.running": "Verifying…",
    "vault.done": "Vault verification complete —",
    "vault.error": "Verification failed",
    "vault.panel.title": "Vault verification",
    "vault.score": "Re-qualified score",
    "vault.labels": "Vault labels taken into account",
    "vault.status.covered": "Covered",
    "vault.status.partial": "Partial",
    "vault.status.gap": "Not covered",
    "vault.gap.title": "Gaps and recommendations",
    "vault.history": "Version history",
    "vault.verified.badge": "Vault verified",
    "footer.labels.dir": "EU-27 label directory",
    "authority.cta": "Enforcement authorities",
    "authority.title": "Report for an enforcement authority",
    "authority.intro": "Pick the country and the enforcement body: EmpCo generates a PDF report in the authority's language, with the full score and timestamp history, the contribution of your certifications and the remaining gaps.",
    "authority.country": "Country", "authority.country.ph": "Select a country",
    "authority.eu": "European Union (EU level)",
    "authority.body": "Enforcement body", "authority.body.ph": "Select a body",
    "authority.site": "Official website",
    "authority.lang": "Report language",
    "authority.lang.hint": "Pre-filled from the authority's country. Label names stay in their original language.",
    "authority.generate": "Generate the report",
    "authority.generating": "Generating…",
    "authority.generated": "Report generated",
    "authority.error": "Generation failed",
    "nav.pricing": "Pricing",
    "nav.method": "Method",
    "nav.legal": "Law",
    "nav.login": "Sign in",
    "nav.dashboard": "Dashboard",
    "nav.logout": "Log out",
    "nav.guides": "Guides",
    "nav.contact": "Contact",
    "contact.eyebrow": "Contact",
    "contact.title": "Let's talk about your compliance",
    "contact.intro": "A question, a demo or a bespoke need? Reach out and pick a time slot — our sales team replies within one working day.",
    "contact.seo.title": "Contact — EmpCo",
    "contact.seo.desc": "Get in touch with EmpCo for a demo, a question about EU Directive 2024/825 or a sales meeting. 24h reply.",
    "contact.f.first_name": "First name",
    "contact.f.last_name": "Last name",
    "contact.f.email": "Email",
    "contact.f.phone": "Phone number",
    "contact.f.company": "Company name",
    "contact.f.message": "Your message (optional)",
    "contact.slots.title": "Book a meeting",
    "contact.slots.desc": "Pick a business day and time — we'll confirm the slot by email.",
    "contact.slots.hours": "Preferred time",
    "contact.slots.chosen": "Chosen slot",
    "contact.submit": "Send",
    "contact.sending": "Sending…",
    "contact.success": "Message sent — we'll get back to you shortly.",
    "contact.success.title": "Thanks for reaching out",
    "contact.success.desc": "Our sales team will reply within one business day at the email address you provided.",
    "contact.err.required": "First name, last name and email are required.",
    "contact.err.generic": "Send failed, please try again.",
    "pay.redirect": "Redirecting to secure payment…",
    "pay.secure": "Secure Stripe payment · VAT calculated automatically",
    "pay.checking": "Verifying payment…",
    "pay.checking.sub": "We are confirming your payment with Stripe. This takes a few seconds.",
    "pay.processing": "Payment confirmed — analysis running",
    "pay.sepa_pending": "SEPA payment initiated",
    "pay.sepa_pending.sub": "Your mandate has been signed. The debit will be confirmed within 3 to 5 business days per SEPA interbank rules. Your subscription will activate automatically once validated. You may close this page.",
    "pay.processing.sub": "Crawling the site and qualifying each claim with AI. Allow 30–90 seconds; you will be redirected automatically.",
    "pay.done": "All set!",
    "pay.done.sub": "Thank you. Redirecting to your workspace…",
    "pay.error": "Something went wrong",
    "pay.error.sub": "The payment could not be confirmed or the scan failed. Contact contact@empco-compliance.eu with the reference below.",
    "pay.timeout": "Still processing",
    "pay.timeout.sub": "Processing is taking longer than expected. Your report will appear in the dashboard within a few minutes.",
    "pay.cancel": "Payment cancelled",
    "pay.cancel.sub": "Nothing was charged. You can restart the payment at any time.",
    "fullscan.included": "Included in your Surveillance plan (1 quota operation per scan).",
    "fullscan.paid": "Website scan €20 ex. VAT — secure Stripe payment, invoice generated automatically.",
    "score.title": "Compliance score",
    "score.hint": "100 = no risky claim. −15 per red claim, −5 per orange.",
    "badge.title": "Shareable badge",
    "badge.hint": "Display your score on your website or materials. The badge links to a public verification page.",
    "badge.copy": "Copy embed code",
    "badge.copied": "Embed code copied",
    "badge.public": "View public badge page →",
    "badge.notfound": "Badge not found.",
    "badge.page.eyebrow": "Compliance score verified by EmpCo",
    "badge.page.scanned": "Scanned on",
    "badge.page.verified": "Website scan with AI qualification",
    "badge.page.free": "Free scan — lexical prefilter",
    "badge.page.disclaimer": "This score is a compliance-assistance indicator based on the analysis of public pages at the stated date. It is not legal advice.",
    "guides.eyebrow": "Compliance guides",
    "guides.title": "Understand and apply EU Directive 2024/825",
    "guides.sub": "Practical articles for marketing, e-commerce and compliance teams: definitions, evidence, rewordings, penalties.",
    "guides.read": "Read the guide",
    "guides.related": "Also read",
    "guides.cta.sub": "Scan your website for free and get your compliance score in 2 minutes.",
    "nav.reports": "Weekly reports",
    "nav.admin": "Corpus admin",
    "scan.ratelimit": "Too many free scans from your address. Try again in an hour or create an account.",
    "reports.eyebrow": "Surveillance",
    "reports.title": "Weekly reports",
    "reports.generate": "Generate now",
    "reports.generated": "Report generated",
    "reports.email.pending": "E-mail delivery pending: no provider (Resend / SendGrid) configured. Reports are generated and archived here; sending will start as soon as an API key is added.",
    "nav.compare": "Compare",
    "nav.subscriptions": "Subscriptions",
    "nav.subscriptions.eyebrow": "Client area",
    "subscriptions.intro": "Pick the plan that fits your needs. All plans include automatic invoicing and VAT calculation.",
    "subscriptions.active": "You are subscribed to Surveillance. Thank you! Manage your billing in the \"Billing\" menu.",
    "subscriptions.cta.sub": "Activate subscription — €200 ex. VAT /mo",
    "subscriptions.cta.scan": "Pay for one scan — €20 ex. VAT",
    "subscriptions.payment_methods": "Pay by credit card or by SEPA direct debit — automatic invoicing and VAT.",
    "billing.intro": "Find all your invoices here. Each one is downloadable as PDF with legal notices and VAT.",
    "nav.how": "How it works",
    "compare.title": "Benchmark against a competitor",
    "compare.sub": "Scan your site and a competitor's in one go. See where you lead… and where you must act.",
    "compare.mine": "Your site",
    "compare.theirs": "Competitor",
    "compare.cta": "Run comparison",
    "compare.loading": "Analysing…",
    "compare.err.miss": "Fill in both URLs",
    "compare.err.fail": "Comparison failed. Check URLs.",
    "compare.verdict": "Verdict",
    "compare.you_lead": "You lead by",
    "compare.they_lead": "You trail by",
    "compare.tie": "Tied, within a claim or two.",
    "compare.deltas": "Category gap",
    "compare.category": "Category",
    "compare.red": "red",
    "compare.orange": "orange",
    "compare.note": "Positive Δ = the competitor has more risky claims than you in that category.",
    "reports.email.ready": "E-mail delivery active via Resend. You receive each report on your account email.",
    "reports.email.sent": "E-mail sent",
    "reports.email.failed": "E-mail failed",
    "reports.email.resend": "Resend email",
    "reports.email.resent": "E-mail re-sent",
    "trust.eyebrow": "Trust badge — Verified by EmpCo",
    "trust.grade": "Grade",
    "trust.red": "Red claims",
    "trust.orange": "Orange claims",
    "trust.proofs": "Uploaded proofs",
    "trust.categories": "Analyzed categories",
    "trust.share": "Share this page",
    "trust.copied": "Link copied",
    "trust.cta": "Verify my site with EmpCo",
    "reports.trend": "Score trend (last 12 weeks)",
    "reports.empty": "No report yet. Surveillance subscribers get an automatic weekly report; you can generate one now.",
    "reports.item": "Weekly report",
    "reports.new": "new",
    "reports.sent": "sent",
    "reports.pending": "e-mail pending",
    "reports.new_claims": "New claims",
    "reports.scans": "This week's scans",
    "reports.expiring": "Evidence expiring within 30 days",
    "reports.first": "First report — nothing to compare yet.",
    "reports.vs": "vs previous week",
    "nav.fullscan": "Website scan",
    "nav.imagescan": "Analyse an image",
    "img.eyebrow": "Image analysis",
    "img.title": "Analyse a packaging, product photo or poster",
    "img.sub": "Drop an image: our AI reads the marketing copy, isolates every environmental claim and qualifies it against EU Directive 2024/825.",
    "img.cta": "Analyse image",
    "img.included": "Included in Surveillance — 1 quota operation per image.",
    "img.paid": "€20 ex. VAT per image — secure Stripe payment, automatic invoice.",
    "img.note": "The image is optimised in your browser before upload. PNG, JPG, WEBP — one image at a time.",
    "img.analyzing": "AI analysis in progress…",
    "img.drop.hint": "Packaging, product photo or poster — or click to browse.",
    "img.landing.eyebrow": "New · Image analysis",
    "img.landing.h": "Your packaging and posters get checked too",
    "img.landing.sub": "Greenwashing doesn't only live on your website. Drop a packaging, label or poster: EmpCo reads the text, flags risky claims and gives you a score in 2 minutes.",
    "img.landing.b1": "OCR + AI: reads the marketing copy straight off the image",
    "img.landing.b2": "Same verdicts and score as the website scan",
    "img.landing.b3": "Perfect to validate a visual before print or publishing",
    "img.landing.included": "Included in the €20 (per unit) and €200/mo (Surveillance) plans.",
    "img.landing.cta": "Analyse my image for free",
    "img.landing.hint": "Free demo · blurred preview · no sign-up required",
    "nav.docscan": "Analyse a document",
    "tab.site": "My website",
    "tab.image": "Image / packaging",
    "tab.document": "Document",
    "doc.eyebrow": "Document analysis",
    "doc.title": "Analyse a spec sheet, a product datasheet…",
    "doc.sub": "Drop a document (PDF, DOCX, TXT): our AI extracts the text, isolates environmental claims and qualifies them against EU Directive 2024/825.",
    "doc.cta": "Analyse document",
    "doc.included": "Included in Surveillance — 1 quota operation per document.",
    "doc.paid": "€20 ex. VAT per document — secure Stripe payment, automatic invoice.",
    "doc.note": "PDF, DOCX or TXT — one document at a time, 10MB max. Text is extracted then analysed, no data resold.",
    "doc.analyzing": "AI analysis in progress…",
    "doc.drop.hint": "Spec sheet, product datasheet, brochure… or click to browse.",
    "doc.landing.cta": "Analyse my document for free",
    "modes.eyebrow": "3 ways to scan",
    "modes.h": "Website, packaging or document: all get checked",
    "modes.sub": "Greenwashing doesn't only live on your website. EmpCo also analyses your visuals and documents with the same legal engine.",
    "modes.site.t": "Your website",
    "modes.site.d": "Crawl up to 200 pages: claims, mentions, product pages — score and dossier in 2 minutes.",
    "modes.image.t": "Product image / packaging",
    "modes.image.d": "Drop a packaging, label or poster: the AI reads the marketing copy and flags risky claims.",
    "modes.document.t": "Document",
    "modes.document.d": "Spec sheet, product datasheet, brochure (PDF/DOCX/TXT): check your claims before release.",
    "modes.foot": "2 free scans, no card. Beyond that: €20 per unit or €200/mo for continuous monitoring.",
    "limit.badge": "Limit reached",
    "limit.title": "You've used your 2 free scans",
    "limit.sub": "Thanks for trying EmpCo! To keep analysing your websites, packaging and documents, pick the plan that suits you.",
    "limit.cta.register": "Create my account",
    "limit.foot": "No commitment · Secure Stripe payment · Data hosted in the EU",
    "cgv.accept.pre": "I have read and accept the",
    "cgv.accept.link": "general terms of sale and use",
    "cgv.required": "You must accept the terms to create your account.",
    "nav.sites": "Sites",
    "nav.proofs": "Evidence vault",
    "nav.alerts": "Alerts",
    "nav.journal": "Journal",
    "nav.workspace": "Workspace",
    "brand.baseline": "Your environmental claims, tested against the law.",
    "brand.baseline.l1": "Your environmental claims,",
    "brand.baseline.l2": "tested against the law.",
    "hero.trust1": "No card required",
    "hero.trust2": "Results in under 2 minutes",
    "hero.trust3": "Data hosted in the EU",
    "hero.card.eyebrow": "Scan in progress",
    "hero.card.pages": "Pages",
    "hero.alert.title": "COSMOS certificate expires in 27 days",
    "kpi.1": "EU Directive 2024/825 enters into application",
    "kpi.2": "Control-ready dossier",
    "kpi.3": "Qualification steps, versioned and traceable",
    "kpi.4": "Of claims with evidence, verdict and history",
    "features.intro": "EmpCo scans your website, isolates every environmental claim, qualifies it against EU Directive 2024/825 and delivers a living register ready for a regulator's audit.",
    "features.quote": "Any environmental claim must be supported by verifiable evidence — EU Directive 2024/825",
    "step.1t": "Website crawl",
    "step.1d": "Exploration of your public pages (≤ 200): copy, tags, product sheets, FAQ.",
    "step.2t": "Lexical prefilter",
    "step.2d": "Versioned FR/EN legal lexicon: “natural”, “carbon neutral”, “eco-friendly”…",
    "step.3t": "AI qualification",
    "step.3d": "Each claim is qualified (red / orange / green), justified and reworded by a Claude model.",
    "step.4t": "Living register",
    "step.4d": "Version, location, verdict and attached evidence for every claim. Nothing gets lost.",
    "step.5t": "Alerts",
    "step.5d": "D-90 / D-30 / D-7 before evidence expires.",
    "step.6t": "PDF dossier",
    "step.6d": "Timestamped control dossier in 1 click.",
    "pricing.popular": "Popular",
    "legal.h": "EU Directive 2024/825 applies from 27 September 2026.",
    "legal.p1": "Published in the Official Journal of the EU on 6 March 2024, it bans generic environmental claims and carbon neutrality based on offsetting alone, and requires substantiation through verifiable third-party evidence.",
    "legal.p2": "Sanctions: administrative fines, product withdrawal, publication of the decision.",
    "legal.cta": "Prepare my dossier",
    "auth.eyebrow": "Business access",
    "auth.register.intro": "Create your workspace in 30 seconds. Only your name and e-mail are required — company and VAT number can be added later for invoicing.",
    "auth.login.intro": "Get back to your living register, alerts and control dossier.",
    "auth.b1": "Full report with compliant rewordings",
    "auth.b2": "Evidence vault and expiry alerts",
    "auth.b3": "Timestamped PDF control dossier",
    "auth.demo_note": "No card required in demo · simulated payment, real invoice generated.",
    "footer.product": "Product",
    "footer.legal": "Legal",
    "footer.directive": "EU Directive 2024/825 · Applies from 27 September 2026",
    "footer.hosting": "Hosted in the EU · EU VAT invoicing",
    "hero.eyebrow": "EU Directive 2024/825 — enforced 27 September 2026",
    "hero.title": "The living register of your environmental claims.",
    "hero.sub": "EmpCo scans your website, detects every environmental claim and qualifies it against EU Directive 2024/825. Living register, evidence, alerts and a control-ready dossier in 24 h. ⚠️ Non-compliance: fines up to 4% of annual turnover, product withdrawal, publication of the decision.",
    "hero.cta": "Scan my site for free",
    "hero.cta2": "See the method",
    "hero.trust": "Used by 40+ FR/UK executives · No card required for the free scan",
    "scan.title": "Free scan",
    "scan.placeholder": "https://your-site.com",
    "scan.button": "Run the scan",
    "scan.loading": "Analyzing (≤15 pages)…",
    "scan.error": "Cannot reach this site. Please check the URL.",
    "report.title": "Limited report",
    "report.pages": "pages scanned",
    "report.red": "Red flags",
    "report.orange": "Orange flags",
    "report.blur": "Details blurred. Unlock the full report + timestamped PDF for €20 ex. VAT.",
    "report.unlock": "Unlock the full report — €20",
    "report.exposure": "Estimated financial exposure",
    "features.h": "What you get",
    "features.1t": "Deterministic detection",
    "features.1d": "Versioned legal lexicon + LLM qualification in batch. No fake ‘auto-compliance’ promises.",
    "features.2t": "Living register",
    "features.2d": "Every claim gets a version, a location, a verdict, and attached evidence. Nothing gets lost.",
    "features.3t": "Alerts D-90 / D-30 / D-7",
    "features.3d": "Certificates expire, so does evidence. We warn you before the regulator does.",
    "features.4t": "1-click control dossier",
    "features.4d": "Timestamped PDF with claims, versions, evidence, verdicts, applicable corpus at date.",
    "pricing.h": "Our offers, no hidden options.",
    "pricing.free": "Free scan",
    "pricing.free.price": "€0",
    "pricing.free.d": "≤ 15 pages · Lexical prefilter · Limited report + email capture",
    "pricing.paid": "A full scan of your choice",
    "billing.activate": "Activate subscription — €200 /month ex. VAT",
    "billing.activate_sub": "Activate subscription — €200 /month ex. VAT",
    "billing.pay_scan": "Pay for one scan — €20 ex. VAT",
    "billing.payment_methods": "Pay by credit card or SEPA direct debit — automatic invoicing & VAT.",
    "pricing.paid.price": "€20 ex. VAT",
    "pricing.paid.old": "40 €",
    "pricing.paid.d": "≤ 200 pages · AI qualification · Rewordings · Risk score · Image analysis (packaging/poster) · Timestamped PDF",
    "pricing.sub": "Scan Annuel + Surveillance",
    "pricing.sub.price": "€200 /mo ex. VAT",
    "pricing.sub.old": "400 € /mois HT",
    "pricing.sub.d": "Weekly recrawl · Versioned register · Evidence vault · Alerts · Image analysis included · 1-click dossier · 3 users · Quota 100",
    "pricing.cta.free": "Start a scan",
    "pricing.cta.paid": "Order — €20 ex. VAT",
    "pricing.cta.sub": "Subscribe — €200 /mo",
    "pricing.enterprise": "Mid-cap / Enterprise",
    "pricing.enterprise.price": "On quote",
    "pricing.enterprise.d": "Unlimited volume · Multi-brand & multi-site · Dedicated SLA · Custom onboarding · Single point of contact · Team training",
    "pricing.cta.enterprise": "Call us",
    "auth.register": "Create an account",
    "auth.login": "Sign in",
    "auth.email": "Work email",
    "auth.pwd": "Password",
    "auth.first": "First name",
    "auth.last": "Last name",
    "auth.company": "Company (optional)",
    "auth.vat": "VAT code (optional)",
    "auth.submit": "Continue",
    "auth.submit_pay": "Create account and pay",
    "auth.plan.title": "Choose your plan",
    "auth.plan.scan": "One-shot full scan",
    "auth.plan.scan.sub": "≤ 200 pages · PDF report · VAT included.",
    "auth.plan.sub": "Surveillance subscription",
    "auth.plan.sub.sub": "Weekly recrawl · D-90/30/7 alerts · control folder · 100 ops/month.",
    "auth.plan.hint": "Pay by credit card or SEPA direct debit. You are redirected after account creation.",
    "auth.plan.required": "Please pick a plan to continue.",
    "auth.have": "Already a member?",
    "auth.no": "No account yet?",
    "dash.title": "Living register",
    "dash.metrics.claims": "Claims",
    "dash.metrics.proofs": "Evidence",
    "dash.metrics.alerts": "Unread alerts",
    "dash.metrics.quota": "Quota",
    "dash.newsite": "Add a site",
    "dash.verify": "Verify ownership",
    "dash.dossier": "Generate control dossier",
    "dash.no_site": "Add a site first and verify ownership.",
    "verdicts.a_couvrir": "to cover",
    "verdicts.couvert": "covered",
    "verdicts.expire": "expired",
    "verdicts.non_conforme": "non-compliant",
    "backoffice.title": "Billing",
    "backoffice.orders": "Orders",
    "backoffice.download": "Download invoice",
    "backoffice.quota": "Surveillance quota",
    "backoffice.plan": "Active plan",
    "common.back": "Back",
    "common.save": "Save",
    "common.cancel": "Cancel",
    "common.close": "Close",
    "common.add": "Add",
    "common.download": "Download",
    "footer.disclaimer": "EmpCo is a compliance-assistance tool. Not legal advice.",
    "cookie.banner.title": "We use cookies",
    "cookie.banner.body": "EmpCo uses strictly necessary technical cookies (session, language), and — with your consent — audience measurement and advertising cookies (Google Analytics and Google Ads) to improve our service and measure our campaigns. Your choices are kept 13 months and can be changed anytime from the footer.",
    "cookie.banner.learn": "Learn more",
    "cookie.btn.accept": "Accept all",
    "cookie.btn.refuse": "Reject all",
    "cookie.btn.customize": "Customize",
    "cookie.btn.save": "Save my choices",
    "cookie.panel.title": "Your cookie preferences",
    "cookie.panel.sub": "You can enable or disable each category",
    "cookie.panel.legal": "In accordance with Regulation (EU) 2016/679 (GDPR) and CNIL deliberation No. 2020-091. Refusing has no consequence on your browsing. Your choices are kept for a maximum of 13 months.",
    "cookie.cat.necessary.title": "Strictly necessary cookies",
    "cookie.cat.necessary.desc": "Essential for the site to work (session, language, security). Exempt from consent (article 82 of French law 1978).",
    "cookie.cat.always": "Always on",
    "cookie.cat.analytics.title": "Audience measurement — Google Analytics",
    "cookie.cat.analytics.desc": "Anonymized traffic statistics to improve our service. Anonymized IP, no data resold.",
    "cookie.cat.ads.title": "Advertising — Google Ads",
    "cookie.cat.ads.desc": "Measurement of our ad campaign performance and display of personalized ads on other sites.",
    "cookie.footer.link": "Cookie settings",
    "legal.directive_cta": "EU Directive",
  },

  de: {
    "vault.cta": "Nachweis-Prüfung",
    "vault.running": "Prüfung läuft…",
    "vault.done": "Nachweis-Prüfung abgeschlossen —",
    "vault.error": "Prüfung fehlgeschlagen",
    "vault.panel.title": "Nachweis-Prüfung",
    "vault.score": "Neu bewerteter Score",
    "vault.labels": "Berücksichtigte Siegel im Tresor",
    "vault.status.covered": "Abgedeckt",
    "vault.status.partial": "Teilweise",
    "vault.status.gap": "Nicht abgedeckt",
    "vault.gap.title": "Lücken und Empfehlungen",
    "vault.history": "Versionsverlauf",
    "vault.verified.badge": "Tresor-geprüft",
    "footer.labels.dir": "EU-27-Siegelverzeichnis",
    "authority.cta": "Aufsichtsbehörden",
    "authority.title": "Bericht für eine Aufsichtsbehörde",
    "authority.intro": "Wählen Sie Land und Behörde: EmpCo erstellt einen PDF-Bericht in der Sprache der Behörde, mit dem vollständigen Verlauf der Scores und Zeitstempel, dem Beitrag Ihrer Zertifizierungen und den verbleibenden Lücken.",
    "authority.country": "Land", "authority.country.ph": "Land auswählen",
    "authority.eu": "Europäische Union (EU-Ebene)",
    "authority.body": "Aufsichtsbehörde", "authority.body.ph": "Behörde auswählen",
    "authority.site": "Offizielle Website",
    "authority.lang": "Sprache des Berichts",
    "authority.lang.hint": "Nach dem Land der Behörde vorbelegt. Siegelnamen bleiben in der Originalsprache.",
    "authority.generate": "Bericht erstellen",
    "authority.generating": "Wird erstellt…",
    "authority.generated": "Bericht erstellt",
    "authority.error": "Erstellung fehlgeschlagen",
    "guides.eyebrow": "Compliance-Ratgeber",
    "guides.title": "Die EU-Richtlinie 2024/825 verstehen und anwenden",
    "guides.sub": "Praxisartikel für Marketing, E-Commerce und Recht: Definitionen, Nachweise, Umformulierungen, Sanktionen.",
    "guides.read": "Ratgeber lesen",
    "guides.related": "Ebenfalls lesenswert",
    "guides.cta.sub": "Scannen Sie Ihre Website kostenlos und sehen Sie Ihre Risikolage in zwei Minuten.",
    "nav.pricing": "Preise",
    "nav.method": "Methode",
    "nav.legal": "Recht",
    "nav.login": "Anmelden",
    "nav.dashboard": "Dashboard",
    "nav.logout": "Abmelden",
    "nav.guides": "Leitfäden",
    "nav.contact": "Kontakt",
    "contact.eyebrow": "Kontakt",
    "contact.title": "Sprechen wir über Ihre Compliance",
    "contact.intro": "Eine Frage, eine Demo oder ein individueller Bedarf? Schreiben Sie uns und wählen Sie einen Zeitraum — unser Vertriebsteam meldet sich innerhalb eines Arbeitstages.",
    "contact.seo.title": "Kontakt — EmpCo",
    "contact.seo.desc": "Kontaktieren Sie EmpCo für eine Demo, eine Frage zur EU-Richtlinie 2024/825 oder einen Vertriebstermin. Antwort innerhalb von 24 Stunden.",
    "contact.f.first_name": "Vorname",
    "contact.f.last_name": "Nachname",
    "contact.f.email": "E-Mail",
    "contact.f.phone": "Telefonnummer",
    "contact.f.company": "Firmenname",
    "contact.f.message": "Ihre Nachricht (optional)",
    "contact.slots.title": "Termin buchen",
    "contact.slots.desc": "Wählen Sie einen Werktag und eine Uhrzeit — wir bestätigen den Termin per E-Mail.",
    "contact.slots.hours": "Wunschzeit",
    "contact.slots.chosen": "Gewählter Termin",
    "contact.submit": "Senden",
    "contact.sending": "Senden…",
    "contact.success": "Nachricht gesendet — wir melden uns in Kürze.",
    "contact.success.title": "Danke für Ihre Nachricht",
    "contact.success.desc": "Unser Vertriebsteam antwortet innerhalb eines Werktages an die angegebene E-Mail-Adresse.",
    "contact.err.required": "Vorname, Nachname und E-Mail sind erforderlich.",
    "contact.err.generic": "Senden fehlgeschlagen, bitte erneut versuchen.",
    "nav.reports": "Wochenbericht",
    "nav.admin": "Admin-Korpus",
    "nav.compare": "Vergleich",
    "nav.subscriptions": "Abonnements",
    "subscriptions.payment_methods": "Zahlung per Kreditkarte oder SEPA-Lastschrift — automatische Rechnungen und USt.",
    "nav.how": "So funktioniert es",
    "nav.alerts": "Alarme",
    "brand.baseline.l1": "Ihre Umweltaussagen,",
    "brand.baseline.l2": "gerichtsfest.",
    "hero.eyebrow": "EU-Richtlinie 2024/825 · Inkrafttreten 27. September 2026",
    "hero.cta": "Kostenlos scannen",
    "hero.sub": "EmpCo scannt Ihre Website, isoliert jede Umweltaussage und qualifiziert sie nach der EU-Richtlinie 2024/825. Lebendes Register, Nachweise, Alarme und Prüfdossier in unter 24 Stunden.",
    "hero.trust1": "Keine Kreditkarte erforderlich",
    "hero.trust2": "Ergebnis in unter 2 Minuten",
    "hero.trust3": "Daten in der EU gehostet",
    "hero.card.eyebrow": "Scan läuft",
    "hero.card.pages": "Seiten",
    "hero.alert.title": "COSMOS-Zertifikat läuft in 27 Tagen ab",
    "scan.placeholder": "https://ihre-website.de",
    "scan.loading": "Scan läuft…",
    "scan.error": "Scan fehlgeschlagen. Prüfen Sie die URL.",
    "scan.ratelimit": "Zu viele kostenlose Scans von Ihrer IP. Versuchen Sie es in einer Stunde oder erstellen Sie ein Konto.",
    "report.red": "Rot markiert",
    "report.orange": "Orange markiert",
    "kpi.1": "Inkrafttreten der EU-Richtlinie 2024/825",
    "kpi.2": "Prüfdossier verfügbar",
    "kpi.3": "Qualifizierungsschritte, versioniert und rückverfolgbar",
    "kpi.4": "Aussagen mit Nachweis, Urteil und Historie",
    "features.h": "Vom Scan bis zum verteidigungsfähigen Beweis, in 6 Schritten.",
    "features.intro": "EmpCo scannt Ihre Website, isoliert jede Umweltaussage, qualifiziert sie im Hinblick auf die EU-Richtlinie 2024/825 und liefert ein lebendes Register, bereit für eine DGCCRF-Kontrolle.",
    "features.quote": "„Eine Aussage ohne Nachweis ist eine verbotene Aussage.“ — EU-Richtlinie 2024/825, Art. 3",
    "step.1t": "Website-Crawl",
    "step.1d": "Erkundung Ihrer öffentlichen Seiten (≤ 200): Texte, Tags, Produktseiten, FAQ.",
    "step.2t": "Lexikalischer Vorfilter",
    "step.2d": "Versioniertes Rechtslexikon DE/FR/EN: „natürlich“, „klimaneutral“, „umweltfreundlich“…",
    "step.3t": "KI-Qualifizierung",
    "step.3d": "Jede Aussage wird von einem Claude-Modell qualifiziert (rot / orange / grün), begründet und umformuliert.",
    "step.4t": "Lebendes Register",
    "step.4d": "Version, Standort, Urteil und angehängte Nachweise für jede Aussage. Nichts geht verloren.",
    "step.5t": "Alarme",
    "step.5d": "T−90 / T−30 / T−7 vor Ablauf eines Nachweises.",
    "step.6t": "PDF-Dossier",
    "step.6d": "Zeitgestempeltes Prüfdossier mit einem Klick.",
    "pricing.h": "Klare, faire und rechtssichere Preise.",
    "pricing.popular": "Beliebt",
    "pricing.free": "Kostenloser Scan",
    "pricing.free.price": "0 €",
    "pricing.free.d": "Bis zu 15 Seiten · Verschwommener Bericht · Ampelanzeige · Kein Konto erforderlich",
    "pricing.cta.free": "Jetzt scannen",
    "pricing.paid": "Ein vollständiger Scan Ihrer Wahl",
    "billing.activate": "Abonnement aktivieren — 200 € /Monat zzgl. USt.",
    "billing.activate_sub": "Abonnement aktivieren — 200 € /Monat zzgl. USt.",
    "billing.pay_scan": "Einen Scan bezahlen — 20 € zzgl. USt.",
    "billing.payment_methods": "Kartenzahlung oder SEPA-Lastschrift möglich — Rechnung & USt. automatisch.",
    "pricing.paid.price": "20 € netto",
    "pricing.paid.old": "40 €",
    "pricing.paid.d": "Bis zu 50 Seiten · Vollständige KI-Qualifizierung · Klartext-Bericht · Downloadbares PDF",
    "pricing.cta.paid": "Vollständigen Scan starten",
    "pricing.sub": "Jahresscan + Überwachung",
    "pricing.sub.price": "200 € /Monat",
    "pricing.sub.old": "400 € /mois HT",
    "pricing.sub.d": "100 Scans/Monat · Wöchentliche Alarme · Nachweistresor · Prüfdossier · Prioritätssupport",
    "pricing.cta.sub": "Überwachung aktivieren",
    "pricing.enterprise": "Mittelstand / Großunternehmen",
    "pricing.enterprise.price": "Auf Anfrage",
    "pricing.enterprise.d": "Unbegrenztes Volumen · Multi-Marken und Multi-Site · Dediziertes SLA · Individuelles Onboarding · Fester Ansprechpartner · Team-Schulungen",
    "pricing.cta.enterprise": "Rufen Sie uns an",
    "legal.h": "Eine europäische Antwort auf eine europäische Anforderung.",
    "legal.p1": "Die Richtlinie 2024/825 verpflichtet jedes Unternehmen, das Umweltaussagen macht, diese mit unabhängig überprüften Nachweisen zu belegen. Verstöße können Bußgelder in Höhe von 4 % des Jahresumsatzes nach sich ziehen.",
    "legal.p2": "EmpCo ist keine Rechtsberatung, sondern ein Werkzeug zur Compliance-Unterstützung, konzipiert mit auf EU-Verbraucherrecht spezialisierten Juristen.",
    "legal.cta": "Konto erstellen und mein Register aufbauen",
    "auth.eyebrow": "Sicherer Zugang",
    "auth.register": "Registrieren",
    "auth.login": "Anmelden",
    "auth.register.intro": "Erstellen Sie Ihr EmpCo-Konto, um ein Register anzulegen, Nachweise zu speichern und Ihr Prüfdossier zu generieren.",
    "auth.login.intro": "Willkommen zurück. Melden Sie sich an, um Ihr Register und Ihre aktiven Alarme zu finden.",
    "auth.b1": "In der EU gehostete Daten, verschlüsselt in Ruhezustand und Übertragung.",
    "auth.b2": "Fälschungssicheres Prüfprotokoll — verteidigungsfähig bei einer Kontrolle.",
    "auth.b3": "Jederzeit exportierbar (PDF, JSON) — Sie bleiben Eigentümer Ihrer Daten.",
    "auth.first": "Vorname",
    "auth.last": "Nachname",
    "auth.company": "Firma (optional)",
    "auth.vat": "USt-IdNr. (optional)",
    "auth.email": "Geschäftliche E-Mail",
    "auth.pwd": "Passwort",
    "auth.submit": "Weiter",
    "auth.submit_pay": "Konto erstellen und bezahlen",
    "auth.plan.title": "Wählen Sie Ihr Paket",
    "auth.plan.scan": "Vollständiger Scan",
    "auth.plan.scan.sub": "≤ 200 Seiten · PDF-Bericht · inkl. USt.",
    "auth.plan.sub": "Überwachungs-Abo",
    "auth.plan.sub.sub": "Wöchentliches Recrawl · Alarme T-90/30/7 · Kontrollakte.",
    "auth.plan.hint": "Zahlung per Kreditkarte oder SEPA-Lastschrift. Weiterleitung nach der Kontoerstellung.",
    "auth.plan.required": "Bitte wählen Sie ein Paket.",
    "auth.have": "Bereits Mitglied?",
    "auth.no": "Noch kein Konto?",
    "auth.demo_note": "Beta-Version — kostenloser Testzeitraum bis 27. September 2026.",
    "footer.disclaimer": "EmpCo ist ein Compliance-Hilfstool. Keine Rechtsberatung.",
    "score.title": "Compliance-Score",
    "trust.eyebrow": "Trust-Badge — Verifiziert von EmpCo",
    "trust.grade": "Note",
    "trust.share": "Diese Seite teilen",
    "trust.cta": "Meine Website mit EmpCo prüfen",
    "cookie.banner.title": "Wir verwenden Cookies",
    "cookie.banner.body": "EmpCo verwendet unbedingt erforderliche technische Cookies (Sitzung, Sprache) und – mit Ihrer Zustimmung – Cookies für Reichweitenmessung und Werbung (Google Analytics und Google Ads), um unseren Dienst zu verbessern und unsere Kampagnen zu messen. Ihre Auswahl wird 13 Monate gespeichert und ist jederzeit über die Fußzeile änderbar.",
    "cookie.banner.learn": "Mehr erfahren",
    "cookie.btn.accept": "Alle akzeptieren",
    "cookie.btn.refuse": "Alle ablehnen",
    "cookie.btn.customize": "Anpassen",
    "cookie.btn.save": "Auswahl speichern",
    "cookie.panel.title": "Ihre Cookie-Einstellungen",
    "cookie.panel.sub": "Sie können jede Kategorie aktivieren oder deaktivieren",
    "cookie.panel.legal": "Gemäß Verordnung (EU) 2016/679 (DSGVO) und CNIL-Beschluss Nr. 2020-091. Ablehnen hat keine Auswirkungen auf Ihre Navigation. Ihre Auswahl wird maximal 13 Monate gespeichert.",
    "cookie.cat.necessary.title": "Unbedingt erforderliche Cookies",
    "cookie.cat.necessary.desc": "Unverzichtbar für den Betrieb der Website (Sitzung, Sprache, Sicherheit). Einwilligungsfrei (Artikel 82).",
    "cookie.cat.always": "Immer aktiv",
    "cookie.cat.analytics.title": "Reichweitenmessung – Google Analytics",
    "cookie.cat.analytics.desc": "Anonymisierte Besucherstatistik zur Verbesserung unseres Dienstes. Anonymisierte IP, keine Datenweitergabe.",
    "cookie.cat.ads.title": "Werbung – Google Ads",
    "cookie.cat.ads.desc": "Messung der Leistung unserer Werbekampagnen und Anzeige personalisierter Werbung auf anderen Websites.",
    "cookie.footer.link": "Cookie-Einstellungen",
    "legal.directive_cta": "EU-Richtlinie",
  },

  es: {
    "vault.cta": "Verificación Caja fuerte",
    "vault.running": "Verificando…",
    "vault.done": "Verificación completada —",
    "vault.error": "Verificación imposible",
    "vault.panel.title": "Verificación Caja fuerte",
    "vault.score": "Puntuación recalificada",
    "vault.labels": "Etiquetas de la caja fuerte consideradas",
    "vault.status.covered": "Cubierto",
    "vault.status.partial": "Parcial",
    "vault.status.gap": "No cubierto",
    "vault.gap.title": "Brechas y recomendaciones",
    "vault.history": "Historial de versiones",
    "vault.verified.badge": "Verificado con pruebas",
    "footer.labels.dir": "Directorio de etiquetas UE-27",
    "authority.cta": "Organismos de control",
    "authority.title": "Informe para una autoridad de control",
    "authority.intro": "Elija el país y el organismo de control: EmpCo genera un informe PDF en el idioma de la autoridad, con el historial completo de puntuaciones y sellos de tiempo, la aportación de sus certificaciones y las brechas restantes.",
    "authority.country": "País", "authority.country.ph": "Elegir un país",
    "authority.eu": "Unión Europea (nivel UE)",
    "authority.body": "Organismo de control", "authority.body.ph": "Elegir un organismo",
    "authority.site": "Sitio oficial",
    "authority.lang": "Idioma del informe",
    "authority.lang.hint": "Predefinido según el país de la autoridad. Los nombres de las etiquetas permanecen en su idioma original.",
    "authority.generate": "Generar el informe",
    "authority.generating": "Generando…",
    "authority.generated": "Informe generado",
    "authority.error": "Generación imposible",
    "guides.eyebrow": "Guías de cumplimiento",
    "guides.title": "Entender y aplicar la Directiva (UE) 2024/825",
    "guides.sub": "Artículos prácticos para marketing, e-commerce y legal: definiciones, pruebas, reformulaciones y sanciones.",
    "guides.read": "Leer la guía",
    "guides.related": "Lea también",
    "guides.cta.sub": "Escanee su web gratis y conozca su exposición al riesgo en dos minutos.",
    "nav.pricing": "Precios",
    "nav.method": "Método",
    "nav.legal": "Ley",
    "nav.login": "Iniciar sesión",
    "nav.dashboard": "Panel",
    "nav.logout": "Cerrar sesión",
    "nav.guides": "Guías",
    "nav.contact": "Contacto",
    "contact.eyebrow": "Contacto",
    "contact.title": "Hablemos de su conformidad",
    "contact.intro": "¿Una pregunta, una demostración o una necesidad a medida? Escríbanos y elija un horario — nuestro equipo comercial responde en un día laborable.",
    "contact.seo.title": "Contacto — EmpCo",
    "contact.seo.desc": "Contacte con EmpCo para una demostración, una pregunta sobre la Directiva UE 2024/825 o una reunión comercial. Respuesta en 24 h.",
    "contact.f.first_name": "Nombre",
    "contact.f.last_name": "Apellido",
    "contact.f.email": "Correo electrónico",
    "contact.f.phone": "Teléfono",
    "contact.f.company": "Nombre de la empresa",
    "contact.f.message": "Su mensaje (opcional)",
    "contact.slots.title": "Reservar una cita",
    "contact.slots.desc": "Elija un día laborable y una hora — confirmaremos por correo electrónico.",
    "contact.slots.hours": "Hora deseada",
    "contact.slots.chosen": "Horario elegido",
    "contact.submit": "Enviar",
    "contact.sending": "Enviando…",
    "contact.success": "Mensaje enviado — le responderemos pronto.",
    "contact.success.title": "Gracias por su mensaje",
    "contact.success.desc": "Nuestro equipo comercial responderá en un día laborable al correo indicado.",
    "contact.err.required": "Nombre, apellido y correo electrónico son obligatorios.",
    "contact.err.generic": "Error al enviar, inténtelo de nuevo.",
    "nav.reports": "Informe semanal",
    "nav.admin": "Corpus admin",
    "nav.compare": "Comparador",
    "nav.subscriptions": "Suscripciones",
    "subscriptions.payment_methods": "Pago con tarjeta o domiciliación SEPA — facturas e IVA automáticos.",
    "nav.how": "Cómo funciona",
    "nav.alerts": "Alertas",
    "brand.baseline.l1": "Sus alegaciones medioambientales,",
    "brand.baseline.l2": "a prueba de la ley.",
    "hero.eyebrow": "Directiva UE 2024/825 · Aplicación 27 septiembre 2026",
    "hero.cta": "Escanear gratis",
    "hero.sub": "EmpCo escanea su sitio web, aísla cada alegación medioambiental y la califica según la directiva UE 2024/825. Registro vivo, pruebas, alertas y expediente de control en menos de 24 horas.",
    "hero.trust1": "Sin tarjeta de crédito",
    "hero.trust2": "Resultado en menos de 2 minutos",
    "hero.trust3": "Datos alojados en la UE",
    "hero.card.eyebrow": "Escaneo en curso",
    "hero.card.pages": "Páginas",
    "hero.alert.title": "El certificado COSMOS expira en 27 días",
    "scan.placeholder": "https://su-sitio.es",
    "scan.loading": "Escaneando…",
    "scan.error": "Escaneo fallido. Compruebe la URL.",
    "scan.ratelimit": "Demasiados escaneos gratuitos desde su IP. Vuelva a intentarlo en una hora o cree una cuenta.",
    "report.red": "Marcados en rojo",
    "report.orange": "Marcados en naranja",
    "kpi.1": "Entrada en vigor de la directiva UE 2024/825",
    "kpi.2": "Expediente de control listo",
    "kpi.3": "Fases de calificación, versionadas y trazables",
    "kpi.4": "Alegaciones con prueba, veredicto e historial",
    "features.h": "Del escaneo a la prueba defendible, en 6 pasos.",
    "features.intro": "EmpCo escanea su sitio, aísla cada alegación medioambiental, la califica frente a la directiva UE 2024/825 y le entrega un registro vivo, listo para una inspección DGCCRF.",
    "features.quote": "Toda alegación ambiental debe poder respaldarse con elementos verificables — Directiva (UE) 2024/825",
    "step.1t": "Crawl del sitio",
    "step.1d": "Exploración de sus páginas públicas (≤ 200): textos, etiquetas, fichas de producto, FAQ.",
    "step.2t": "Prefiltro léxico",
    "step.2d": "Léxico jurídico versionado ES/FR/EN: «natural», «neutro en carbono», «ecorresponsable»…",
    "step.3t": "Calificación IA",
    "step.3d": "Cada alegación es calificada (roja / naranja / verde), motivada y reformulada por un modelo Claude.",
    "step.4t": "Registro vivo",
    "step.4d": "Versión, ubicación, veredicto y pruebas adjuntas para cada alegación. Nada se pierde.",
    "step.5t": "Alertas",
    "step.5d": "J−90 / J−30 / J−7 antes de la expiración de una prueba.",
    "step.6t": "Expediente PDF",
    "step.6d": "Expediente de control con marca de tiempo en 1 clic.",
    "pricing.h": "Precios claros, justos y jurídicamente sólidos.",
    "pricing.popular": "Popular",
    "pricing.free": "Escaneo gratuito",
    "pricing.free.price": "0 €",
    "pricing.free.d": "Hasta 15 páginas · Informe difuminado · Indicador semáforo · Sin cuenta requerida",
    "pricing.cta.free": "Escanear ahora",
    "pricing.paid": "Un escaneo completo a elegir",
    "billing.activate": "Activar suscripción — 200 € /mes sin IVA",
    "billing.activate_sub": "Activar suscripción — 200 € /mes sin IVA",
    "billing.pay_scan": "Pagar un escaneo — 20 € sin IVA",
    "billing.payment_methods": "Pago con tarjeta o domiciliación SEPA — facturas e IVA automáticos.",
    "pricing.paid.price": "20 € IVA no incl.",
    "pricing.paid.old": "40 €",
    "pricing.paid.d": "Hasta 50 páginas · Calificación IA completa · Informe legible · PDF descargable",
    "pricing.cta.paid": "Iniciar escaneo completo",
    "pricing.sub": "Escaneo Anual + Vigilancia",
    "pricing.sub.price": "200 € /mes",
    "pricing.sub.old": "400 € /mois HT",
    "pricing.sub.d": "100 escaneos/mes · Alertas semanales · Caja fuerte de pruebas · Expediente de control · Soporte prioritario",
    "pricing.cta.sub": "Activar Vigilancia",
    "pricing.enterprise": "Mediana / Gran empresa",
    "pricing.enterprise.price": "Bajo presupuesto",
    "pricing.enterprise.d": "Volumen ilimitado · Multi-marca y multi-sitio · SLA dedicado · Onboarding a medida · Interlocutor único · Formación de equipos",
    "pricing.cta.enterprise": "Llámenos",
    "legal.h": "Una respuesta europea a una exigencia europea.",
    "legal.p1": "La directiva 2024/825 obliga a toda empresa que realice alegaciones medioambientales a respaldarlas con pruebas verificadas por un tercero independiente. La infracción puede acarrear sanciones de hasta el 4 % del volumen de negocio anual.",
    "legal.p2": "EmpCo no es asesoría jurídica sino una herramienta de asistencia al cumplimiento, diseñada con juristas especializados en derecho del consumo europeo.",
    "legal.cta": "Crear cuenta y construir mi registro",
    "auth.eyebrow": "Acceso seguro",
    "auth.register": "Registrarse",
    "auth.login": "Iniciar sesión",
    "auth.register.intro": "Cree su cuenta EmpCo para construir un registro, guardar sus pruebas y generar su expediente de control.",
    "auth.login.intro": "Bienvenido de nuevo. Inicie sesión para recuperar su registro y sus alertas activas.",
    "auth.b1": "Datos alojados en la UE, cifrados en reposo y en tránsito.",
    "auth.b2": "Registro de auditoría infalsificable — defendible ante una inspección.",
    "auth.b3": "Exportación en cualquier momento (PDF, JSON) — usted es propietario de sus datos.",
    "auth.first": "Nombre",
    "auth.last": "Apellido",
    "auth.company": "Empresa (opcional)",
    "auth.vat": "Número de IVA (opcional)",
    "auth.email": "Correo profesional",
    "auth.pwd": "Contraseña",
    "auth.submit": "Continuar",
    "auth.submit_pay": "Crear cuenta y pagar",
    "auth.plan.title": "Elija su plan",
    "auth.plan.scan": "Escaneo completo",
    "auth.plan.scan.sub": "≤ 200 páginas · informe PDF · IVA incluido.",
    "auth.plan.sub": "Suscripción Vigilancia",
    "auth.plan.sub.sub": "Recrawl semanal · alertas D-90/30/7 · carpeta de control.",
    "auth.plan.hint": "Pago con tarjeta o domiciliación SEPA. Redirigido tras crear la cuenta.",
    "auth.plan.required": "Elija un plan para continuar.",
    "auth.have": "¿Ya es miembro?",
    "auth.no": "¿Aún no tiene cuenta?",
    "auth.demo_note": "Versión beta — período de prueba gratuito hasta el 27 de septiembre de 2026.",
    "footer.disclaimer": "EmpCo es una herramienta de asistencia al cumplimiento. No constituye asesoría legal.",
    "score.title": "Puntuación de conformidad",
    "trust.eyebrow": "Trust badge — Verificado por EmpCo",
    "trust.grade": "Nota",
    "trust.share": "Compartir esta página",
    "trust.cta": "Verificar mi sitio con EmpCo",
    "cookie.banner.title": "Utilizamos cookies",
    "cookie.banner.body": "EmpCo utiliza cookies técnicas estrictamente necesarias (sesión, idioma) y — con su consentimiento — cookies de medición de audiencia y publicidad (Google Analytics y Google Ads) para mejorar nuestro servicio y medir nuestras campañas. Sus elecciones se conservan 13 meses y pueden modificarse en cualquier momento desde el pie de página.",
    "cookie.banner.learn": "Saber más",
    "cookie.btn.accept": "Aceptar todo",
    "cookie.btn.refuse": "Rechazar todo",
    "cookie.btn.customize": "Personalizar",
    "cookie.btn.save": "Guardar mis elecciones",
    "cookie.panel.title": "Sus preferencias de cookies",
    "cookie.panel.sub": "Puede activar o desactivar cada categoría",
    "cookie.panel.legal": "Conforme al Reglamento (UE) 2016/679 (RGPD) y la deliberación CNIL n.º 2020-091. Rechazar no afecta a su navegación. Sus elecciones se conservan un máximo de 13 meses.",
    "cookie.cat.necessary.title": "Cookies estrictamente necesarias",
    "cookie.cat.necessary.desc": "Indispensables para el funcionamiento del sitio (sesión, idioma, seguridad). Exentas de consentimiento.",
    "cookie.cat.always": "Siempre activas",
    "cookie.cat.analytics.title": "Medición de audiencia — Google Analytics",
    "cookie.cat.analytics.desc": "Estadísticas anonimizadas de tráfico para mejorar nuestro servicio. IP anonimizada, sin reventa de datos.",
    "cookie.cat.ads.title": "Publicidad — Google Ads",
    "cookie.cat.ads.desc": "Medición del rendimiento de nuestras campañas y visualización de anuncios personalizados en otros sitios.",
    "cookie.footer.link": "Preferencias de cookies",
    "legal.directive_cta": "Directiva UE",
  },

  it: {
    "vault.cta": "Verifica Cassaforte",
    "vault.running": "Verifica in corso…",
    "vault.done": "Verifica completata —",
    "vault.error": "Verifica non riuscita",
    "vault.panel.title": "Verifica Cassaforte",
    "vault.score": "Punteggio riqualificato",
    "vault.labels": "Etichette della cassaforte considerate",
    "vault.status.covered": "Coperto",
    "vault.status.partial": "Parziale",
    "vault.status.gap": "Non coperto",
    "vault.gap.title": "Scostamenti e raccomandazioni",
    "vault.history": "Cronologia versioni",
    "vault.verified.badge": "Verificato con prove",
    "footer.labels.dir": "Elenco etichette UE-27",
    "authority.cta": "Organismi di controllo",
    "authority.title": "Rendiconto per un'autorità di controllo",
    "authority.intro": "Scegli il paese e l'organismo di controllo: EmpCo genera un rendiconto PDF nella lingua dell'autorità, con lo storico completo dei punteggi e delle marche temporali, l'apporto delle tue certificazioni e gli scostamenti residui.",
    "authority.country": "Paese", "authority.country.ph": "Scegli un paese",
    "authority.eu": "Unione europea (livello UE)",
    "authority.body": "Organismo di controllo", "authority.body.ph": "Scegli un organismo",
    "authority.site": "Sito ufficiale",
    "authority.lang": "Lingua del rendiconto",
    "authority.lang.hint": "Precompilata in base al paese dell'autorità. I nomi delle etichette restano nella lingua originale.",
    "authority.generate": "Genera il rendiconto",
    "authority.generating": "Generazione…",
    "authority.generated": "Rendiconto generato",
    "authority.error": "Generazione non riuscita",
    "guides.eyebrow": "Guide di conformità",
    "guides.title": "Capire e applicare la Direttiva (UE) 2024/825",
    "guides.sub": "Articoli pratici per marketing, e-commerce e legale: definizioni, prove, riformulazioni, sanzioni.",
    "guides.read": "Leggi la guida",
    "guides.related": "Da leggere anche",
    "guides.cta.sub": "Scansiona gratis il tuo sito e scopri la tua esposizione in due minuti.",
    "nav.pricing": "Prezzi",
    "nav.method": "Metodo",
    "nav.legal": "Legge",
    "nav.login": "Accedi",
    "nav.dashboard": "Dashboard",
    "nav.logout": "Esci",
    "nav.guides": "Guide",
    "nav.contact": "Contatto",
    "contact.eyebrow": "Contatto",
    "contact.title": "Parliamo della sua conformità",
    "contact.intro": "Una domanda, una demo o un'esigenza personalizzata? Ci scriva e scelga un orario — il team commerciale risponde entro un giorno lavorativo.",
    "contact.seo.title": "Contatto — EmpCo",
    "contact.seo.desc": "Contatti EmpCo per una demo, una domanda sulla Direttiva UE 2024/825 o un incontro commerciale. Risposta entro 24 ore.",
    "contact.f.first_name": "Nome",
    "contact.f.last_name": "Cognome",
    "contact.f.email": "Email",
    "contact.f.phone": "Telefono",
    "contact.f.company": "Nome dell'azienda",
    "contact.f.message": "Il suo messaggio (opzionale)",
    "contact.slots.title": "Fissare un appuntamento",
    "contact.slots.desc": "Scelga un giorno feriale e un'ora — confermeremo via email.",
    "contact.slots.hours": "Ora preferita",
    "contact.slots.chosen": "Orario scelto",
    "contact.submit": "Invia",
    "contact.sending": "Invio…",
    "contact.success": "Messaggio inviato — la ricontatteremo presto.",
    "contact.success.title": "Grazie per il suo messaggio",
    "contact.success.desc": "Il team commerciale risponderà entro un giorno lavorativo all'email indicata.",
    "contact.err.required": "Nome, cognome ed email sono obbligatori.",
    "contact.err.generic": "Invio fallito, riprovi.",
    "nav.reports": "Report settimanale",
    "nav.admin": "Corpus admin",
    "nav.compare": "Comparatore",
    "nav.subscriptions": "Abbonamenti",
    "subscriptions.payment_methods": "Pagamento con carta o addebito SEPA — fatturazione e IVA automatiche.",
    "nav.how": "Come funziona",
    "nav.alerts": "Avvisi",
    "brand.baseline.l1": "Le vostre dichiarazioni ambientali,",
    "brand.baseline.l2": "a prova di legge.",
    "hero.eyebrow": "Direttiva UE 2024/825 · Applicazione 27 settembre 2026",
    "hero.cta": "Scansiona gratis",
    "hero.sub": "EmpCo scansiona il vostro sito, isola ogni dichiarazione ambientale e la qualifica secondo la direttiva UE 2024/825. Registro vivo, prove, avvisi e dossier di controllo in meno di 24 ore.",
    "hero.trust1": "Nessuna carta di credito richiesta",
    "hero.trust2": "Risultato in meno di 2 minuti",
    "hero.trust3": "Dati ospitati nell'UE",
    "hero.card.eyebrow": "Scansione in corso",
    "hero.card.pages": "Pagine",
    "hero.alert.title": "Il certificato COSMOS scade tra 27 giorni",
    "scan.placeholder": "https://il-vostro-sito.it",
    "scan.loading": "Scansione in corso…",
    "scan.error": "Scansione fallita. Verificate l'URL.",
    "scan.ratelimit": "Troppe scansioni gratuite dal vostro IP. Riprovate tra un'ora o create un account.",
    "report.red": "Segnalati rossi",
    "report.orange": "Segnalati arancioni",
    "kpi.1": "Entrata in vigore della direttiva UE 2024/825",
    "kpi.2": "Dossier di controllo pronto",
    "kpi.3": "Fasi di qualificazione, versionate e tracciabili",
    "kpi.4": "Dichiarazioni con prova, verdetto e cronologia",
    "features.h": "Dalla scansione alla prova difendibile, in 6 passaggi.",
    "features.intro": "EmpCo scansiona il vostro sito, isola ogni dichiarazione ambientale, la qualifica rispetto alla direttiva UE 2024/825 e vi consegna un registro vivo, pronto per un controllo DGCCRF.",
    "features.quote": "Ogni dichiarazione ambientale deve poter essere supportata da elementi verificabili — Direttiva (UE) 2024/825",
    "step.1t": "Crawl del sito",
    "step.1d": "Esplorazione delle vostre pagine pubbliche (≤ 200): testi, tag, schede prodotto, FAQ.",
    "step.2t": "Prefiltro lessicale",
    "step.2d": "Lessico giuridico versionato IT/FR/EN: «naturale», «carbon neutral», «eco-responsabile»…",
    "step.3t": "Qualificazione IA",
    "step.3d": "Ogni dichiarazione è qualificata (rossa / arancione / verde), motivata e riformulata da un modello Claude.",
    "step.4t": "Registro vivo",
    "step.4d": "Versione, posizione, verdetto e prove allegate per ogni dichiarazione. Nulla va perso.",
    "step.5t": "Avvisi",
    "step.5d": "G−90 / G−30 / G−7 prima della scadenza di una prova.",
    "step.6t": "Dossier PDF",
    "step.6d": "Dossier di controllo con timestamp in 1 clic.",
    "pricing.h": "Prezzi chiari, equi e giuridicamente solidi.",
    "pricing.popular": "Popolare",
    "pricing.free": "Scansione gratuita",
    "pricing.free.price": "0 €",
    "pricing.free.d": "Fino a 15 pagine · Report offuscato · Indicatore semaforico · Nessun account richiesto",
    "pricing.cta.free": "Scansiona ora",
    "pricing.paid": "Una scansione completa a scelta",
    "billing.activate": "Attivare l'abbonamento — 200 € /mese IVA esclusa",
    "billing.activate_sub": "Attivare l'abbonamento — 200 € /mese IVA esclusa",
    "billing.pay_scan": "Pagare una scansione — 20 € IVA esclusa",
    "billing.payment_methods": "Pagamento con carta o addebito SEPA — fatturazione e IVA automatiche.",
    "pricing.paid.price": "20 € IVA escl.",
    "pricing.paid.old": "40 €",
    "pricing.paid.d": "Fino a 50 pagine · Qualificazione IA completa · Report leggibile · PDF scaricabile",
    "pricing.cta.paid": "Avvia scansione completa",
    "pricing.sub": "Scansione Annuale + Sorveglianza",
    "pricing.sub.price": "200 € /mese",
    "pricing.sub.old": "400 € /mois HT",
    "pricing.sub.d": "100 scansioni/mese · Avvisi settimanali · Cassaforte prove · Dossier di controllo · Supporto prioritario",
    "pricing.cta.sub": "Attiva Sorveglianza",
    "pricing.enterprise": "PMI / Grande impresa",
    "pricing.enterprise.price": "Su preventivo",
    "pricing.enterprise.d": "Volume illimitato · Multi-brand e multi-sito · SLA dedicato · Onboarding su misura · Interlocutore unico · Formazione team",
    "pricing.cta.enterprise": "Chiamateci",
    "legal.h": "Una risposta europea a un'esigenza europea.",
    "legal.p1": "La direttiva 2024/825 obbliga ogni azienda che formula dichiarazioni ambientali a supportarle con prove verificate da terzi indipendenti. La violazione può comportare sanzioni fino al 4 % del fatturato annuo.",
    "legal.p2": "EmpCo non è una consulenza legale ma uno strumento di assistenza alla conformità, progettato con giuristi specializzati in diritto europeo dei consumatori.",
    "legal.cta": "Creare un account e costruire il mio registro",
    "auth.eyebrow": "Accesso sicuro",
    "auth.register": "Registrati",
    "auth.login": "Accedi",
    "auth.register.intro": "Crea il tuo account EmpCo per costruire un registro, conservare le prove e generare il tuo dossier di controllo.",
    "auth.login.intro": "Bentornato. Accedi per ritrovare il tuo registro e i tuoi avvisi attivi.",
    "auth.b1": "Dati ospitati nell'UE, cifrati a riposo e in transito.",
    "auth.b2": "Registro di audit inalterabile — difendibile in caso di controllo.",
    "auth.b3": "Esportazione in qualsiasi momento (PDF, JSON) — tu sei proprietario dei tuoi dati.",
    "auth.first": "Nome",
    "auth.last": "Cognome",
    "auth.company": "Azienda (opzionale)",
    "auth.vat": "Partita IVA (opzionale)",
    "auth.email": "E-mail aziendale",
    "auth.pwd": "Password",
    "auth.submit": "Continua",
    "auth.submit_pay": "Crea account e paga",
    "auth.plan.title": "Scegli il tuo piano",
    "auth.plan.scan": "Scansione completa",
    "auth.plan.scan.sub": "≤ 200 pagine · report PDF · IVA inclusa.",
    "auth.plan.sub": "Abbonamento Sorveglianza",
    "auth.plan.sub.sub": "Recrawl settimanale · avvisi G-90/30/7 · dossier di controllo.",
    "auth.plan.hint": "Pagamento con carta o addebito SEPA. Reindirizzato dopo la creazione dell'account.",
    "auth.plan.required": "Scelga un piano per continuare.",
    "auth.have": "Sei già iscritto?",
    "auth.no": "Non hai ancora un account?",
    "auth.demo_note": "Versione beta — periodo di prova gratuito fino al 27 settembre 2026.",
    "footer.disclaimer": "EmpCo è uno strumento di assistenza alla conformità. Non costituisce consulenza legale.",
    "score.title": "Punteggio di conformità",
    "trust.eyebrow": "Trust badge — Verificato da EmpCo",
    "trust.grade": "Voto",
    "trust.share": "Condividi questa pagina",
    "trust.cta": "Verifica il mio sito con EmpCo",
    "cookie.banner.title": "Utilizziamo cookie",
    "cookie.banner.body": "EmpCo utilizza cookie tecnici strettamente necessari (sessione, lingua) e — con il tuo consenso — cookie di misurazione del pubblico e pubblicità (Google Analytics e Google Ads) per migliorare il nostro servizio e misurare le nostre campagne. Le tue scelte vengono conservate per 13 mesi e possono essere modificate in qualsiasi momento dal footer.",
    "cookie.banner.learn": "Scopri di più",
    "cookie.btn.accept": "Accetta tutto",
    "cookie.btn.refuse": "Rifiuta tutto",
    "cookie.btn.customize": "Personalizza",
    "cookie.btn.save": "Salva le mie scelte",
    "cookie.panel.title": "Le tue preferenze cookie",
    "cookie.panel.sub": "Puoi attivare o disattivare ogni categoria",
    "cookie.panel.legal": "Ai sensi del Regolamento (UE) 2016/679 (GDPR) e della delibera CNIL n. 2020-091. Rifiutare non ha alcuna conseguenza sulla navigazione. Le scelte sono conservate al massimo 13 mesi.",
    "cookie.cat.necessary.title": "Cookie strettamente necessari",
    "cookie.cat.necessary.desc": "Indispensabili per il funzionamento del sito (sessione, lingua, sicurezza). Esenti da consenso.",
    "cookie.cat.always": "Sempre attivi",
    "cookie.cat.analytics.title": "Misurazione pubblico — Google Analytics",
    "cookie.cat.analytics.desc": "Statistiche anonime di traffico per migliorare il servizio. IP anonimizzato, nessun dato rivenduto.",
    "cookie.cat.ads.title": "Pubblicità — Google Ads",
    "cookie.cat.ads.desc": "Misurazione delle prestazioni delle nostre campagne pubblicitarie e visualizzazione di annunci personalizzati.",
    "cookie.footer.link": "Impostazioni cookie",
    "legal.directive_cta": "Direttiva UE",
  },

  nl: {
    "vault.cta": "Kluisverificatie",
    "vault.running": "Verifiëren…",
    "vault.done": "Kluisverificatie voltooid —",
    "vault.error": "Verificatie mislukt",
    "vault.panel.title": "Kluisverificatie",
    "vault.score": "Herberekende score",
    "vault.labels": "Meegenomen keurmerken uit de kluis",
    "vault.status.covered": "Gedekt",
    "vault.status.partial": "Gedeeltelijk",
    "vault.status.gap": "Niet gedekt",
    "vault.gap.title": "Afwijkingen en aanbevelingen",
    "vault.history": "Versiegeschiedenis",
    "vault.verified.badge": "Kluis-geverifieerd",
    "footer.labels.dir": "EU-27 labelgids",
    "authority.cta": "Toezichthouders",
    "authority.title": "Verslag voor een toezichthouder",
    "authority.intro": "Kies het land en de toezichthouder: EmpCo genereert een PDF-verslag in de taal van de autoriteit, met de volledige geschiedenis van scores en tijdstempels, de bijdrage van uw certificeringen en de resterende afwijkingen.",
    "authority.country": "Land", "authority.country.ph": "Kies een land",
    "authority.eu": "Europese Unie (EU-niveau)",
    "authority.body": "Toezichthouder", "authority.body.ph": "Kies een instantie",
    "authority.site": "Officiële website",
    "authority.lang": "Taal van het verslag",
    "authority.lang.hint": "Voorgevuld op basis van het land van de autoriteit. Keurmerknamen blijven in de oorspronkelijke taal.",
    "authority.generate": "Verslag genereren",
    "authority.generating": "Genereren…",
    "authority.generated": "Verslag gegenereerd",
    "authority.error": "Genereren mislukt",
    "guides.eyebrow": "Compliance-gidsen",
    "guides.title": "Richtlijn (EU) 2024/825 begrijpen en toepassen",
    "guides.sub": "Praktische artikelen voor marketing, e-commerce en legal: definities, bewijs, herformuleringen, sancties.",
    "guides.read": "Gids lezen",
    "guides.related": "Ook interessant",
    "guides.cta.sub": "Scan uw website gratis en zie uw risicopositie binnen twee minuten.",
    "nav.pricing": "Prijzen",
    "nav.method": "Methode",
    "nav.legal": "Wet",
    "nav.login": "Inloggen",
    "nav.dashboard": "Dashboard",
    "nav.logout": "Uitloggen",
    "nav.guides": "Gidsen",
    "nav.contact": "Contact",
    "contact.eyebrow": "Contact",
    "contact.title": "Laten we uw compliance bespreken",
    "contact.intro": "Een vraag, een demo of een specifieke behoefte? Neem contact op en kies een tijdslot — ons salesteam antwoordt binnen één werkdag.",
    "contact.seo.title": "Contact — EmpCo",
    "contact.seo.desc": "Neem contact op met EmpCo voor een demo, een vraag over de EU-richtlijn 2024/825 of een verkoopgesprek. Reactie binnen 24 uur.",
    "contact.f.first_name": "Voornaam",
    "contact.f.last_name": "Achternaam",
    "contact.f.email": "E-mail",
    "contact.f.phone": "Telefoonnummer",
    "contact.f.company": "Bedrijfsnaam",
    "contact.f.message": "Uw bericht (optioneel)",
    "contact.slots.title": "Afspraak maken",
    "contact.slots.desc": "Kies een werkdag en een tijd — we bevestigen per e-mail.",
    "contact.slots.hours": "Gewenste tijd",
    "contact.slots.chosen": "Gekozen moment",
    "contact.submit": "Verzenden",
    "contact.sending": "Verzenden…",
    "contact.success": "Bericht verzonden — we nemen snel contact op.",
    "contact.success.title": "Bedankt voor uw bericht",
    "contact.success.desc": "Ons salesteam reageert binnen één werkdag op het opgegeven e-mailadres.",
    "contact.err.required": "Voornaam, achternaam en e-mail zijn verplicht.",
    "contact.err.generic": "Verzenden mislukt, probeer opnieuw.",
    "nav.reports": "Wekelijks rapport",
    "nav.admin": "Admin-corpus",
    "nav.compare": "Vergelijker",
    "nav.subscriptions": "Abonnementen",
    "subscriptions.payment_methods": "Betaling per creditcard of SEPA-incasso — automatische facturen en btw.",
    "nav.how": "Hoe werkt het",
    "nav.alerts": "Meldingen",
    "brand.baseline.l1": "Uw milieuclaims,",
    "brand.baseline.l2": "juridisch waterdicht.",
    "hero.eyebrow": "EU-richtlijn 2024/825 · Inwerkingtreding 27 september 2026",
    "hero.cta": "Gratis scannen",
    "hero.sub": "EmpCo scant uw website, isoleert elke milieuclaim en kwalificeert deze volgens EU-richtlijn 2024/825. Levend register, bewijsstukken, meldingen en controledossier binnen 24 uur.",
    "hero.trust1": "Geen creditcard nodig",
    "hero.trust2": "Resultaat binnen 2 minuten",
    "hero.trust3": "Data gehost in de EU",
    "hero.card.eyebrow": "Scan bezig",
    "hero.card.pages": "Pagina's",
    "hero.alert.title": "COSMOS-certificaat verloopt over 27 dagen",
    "scan.placeholder": "https://uw-website.nl",
    "scan.loading": "Scannen…",
    "scan.error": "Scan mislukt. Controleer de URL.",
    "scan.ratelimit": "Te veel gratis scans vanaf uw IP. Probeer het over een uur opnieuw of maak een account aan.",
    "report.red": "Rood gemarkeerd",
    "report.orange": "Oranje gemarkeerd",
    "kpi.1": "Inwerkingtreding EU-richtlijn 2024/825",
    "kpi.2": "Controledossier gereed",
    "kpi.3": "Kwalificatiestappen, geversioneerd en traceerbaar",
    "kpi.4": "Claims met bewijs, oordeel en historiek",
    "features.h": "Van scan tot verdedigbaar bewijs, in 6 stappen.",
    "features.intro": "EmpCo scant uw site, isoleert elke milieuclaim, kwalificeert deze volgens EU-richtlijn 2024/825 en levert u een levend register — klaar voor een DGCCRF-controle.",
    "features.quote": "Elke milieuclaim moet met verifieerbare elementen kunnen worden onderbouwd — EU-richtlijn 2024/825",
    "step.1t": "Site-crawl",
    "step.1d": "Verkenning van uw openbare pagina's (≤ 200): teksten, tags, productbladen, FAQ.",
    "step.2t": "Lexicale voorfilter",
    "step.2d": "Versioneerd juridisch lexicon NL/FR/EN: „natuurlijk\", „CO₂-neutraal\", „milieuvriendelijk\"…",
    "step.3t": "AI-kwalificatie",
    "step.3d": "Elke claim wordt door een Claude-model gekwalificeerd (rood / oranje / groen), gemotiveerd en geherformuleerd.",
    "step.4t": "Levend register",
    "step.4d": "Versie, locatie, oordeel en bijgevoegde bewijzen voor elke claim. Niets gaat verloren.",
    "step.5t": "Meldingen",
    "step.5d": "D−90 / D−30 / D−7 voor het verlopen van een bewijsstuk.",
    "step.6t": "PDF-dossier",
    "step.6d": "Tijdgestempeld controledossier met één klik.",
    "pricing.h": "Duidelijke, eerlijke en juridisch onderbouwde tarieven.",
    "pricing.popular": "Populair",
    "pricing.free": "Gratis scan",
    "pricing.free.price": "€ 0",
    "pricing.free.d": "Tot 15 pagina's · Vervaagd rapport · Verkeerslichtindicator · Geen account nodig",
    "pricing.cta.free": "Nu scannen",
    "pricing.paid": "Een volledige scan naar keuze",
    "billing.activate": "Abonnement activeren — € 200 /maand excl. btw",
    "billing.activate_sub": "Abonnement activeren — € 200 /maand excl. btw",
    "billing.pay_scan": "Betaal één scan — € 20 excl. btw",
    "billing.payment_methods": "Betaling per creditcard of SEPA-incasso — automatische facturen en btw.",
    "pricing.paid.price": "€ 15 excl. btw",
    "pricing.paid.old": "40 €",
    "pricing.paid.d": "Tot 50 pagina's · Volledige AI-kwalificatie · Leesbaar rapport · Downloadbare PDF",
    "pricing.cta.paid": "Volledige scan starten",
    "pricing.sub": "Jaarlijkse Scan + Bewaking",
    "pricing.sub.price": "€ 99 /maand",
    "pricing.sub.old": "400 € /mois HT",
    "pricing.sub.d": "100 scans/maand · Wekelijkse meldingen · Bewijskluis · Controledossier · Prioritaire ondersteuning",
    "pricing.cta.sub": "Bewaking activeren",
    "pricing.enterprise": "MKB / Grote onderneming",
    "pricing.enterprise.price": "Op offerte",
    "pricing.enterprise.d": "Onbeperkt volume · Multi-merk en multi-site · Toegewijde SLA · Onboarding op maat · Vast aanspreekpunt · Teamtrainingen",
    "pricing.cta.enterprise": "Bel ons",
    "legal.h": "Een Europees antwoord op een Europese eis.",
    "legal.p1": "Richtlijn 2024/825 verplicht elk bedrijf dat milieuclaims doet, deze te onderbouwen met bewijzen die door een onafhankelijke derde partij zijn geverifieerd. Overtredingen kunnen leiden tot boetes tot 4 % van de jaaromzet.",
    "legal.p2": "EmpCo is geen juridisch advies maar een compliance-hulpmiddel, ontworpen samen met juristen gespecialiseerd in Europees consumentenrecht.",
    "legal.cta": "Account aanmaken en mijn register opbouwen",
    "auth.eyebrow": "Beveiligde toegang",
    "auth.register": "Registreren",
    "auth.login": "Inloggen",
    "auth.register.intro": "Maak uw EmpCo-account aan om een register op te bouwen, bewijzen op te slaan en uw controledossier te genereren.",
    "auth.login.intro": "Welkom terug. Log in om uw register en actieve meldingen op te halen.",
    "auth.b1": "Data gehost in de EU, versleuteld in rust en tijdens overdracht.",
    "auth.b2": "Onvervalsbaar auditlogboek — verdedigbaar bij een controle.",
    "auth.b3": "Exporteerbaar op elk moment (PDF, JSON) — u blijft eigenaar van uw data.",
    "auth.first": "Voornaam",
    "auth.last": "Achternaam",
    "auth.company": "Bedrijf (optioneel)",
    "auth.vat": "Btw-nummer (optioneel)",
    "auth.email": "Zakelijke e-mail",
    "auth.pwd": "Wachtwoord",
    "auth.submit": "Doorgaan",
    "auth.submit_pay": "Account aanmaken en betalen",
    "auth.plan.title": "Kies uw pakket",
    "auth.plan.scan": "Volledige scan",
    "auth.plan.scan.sub": "≤ 200 pagina's · pdf-rapport · btw inbegrepen.",
    "auth.plan.sub": "Toezicht-abonnement",
    "auth.plan.sub.sub": "Wekelijkse recrawl · waarschuwingen D-90/30/7 · controledossier.",
    "auth.plan.hint": "Betaling per creditcard of SEPA-incasso. Doorverwijzing na accountaanmaak.",
    "auth.plan.required": "Kies een pakket om verder te gaan.",
    "auth.have": "Al lid?",
    "auth.no": "Nog geen account?",
    "auth.demo_note": "Bèta-versie — gratis testperiode tot 27 september 2026.",
    "footer.disclaimer": "EmpCo is een compliance-hulpmiddel. Geen juridisch advies.",
    "score.title": "Compliance-score",
    "trust.eyebrow": "Trust badge — Geverifieerd door EmpCo",
    "trust.grade": "Cijfer",
    "trust.share": "Deze pagina delen",
    "trust.cta": "Mijn website verifiëren met EmpCo",
    "cookie.banner.title": "Wij gebruiken cookies",
    "cookie.banner.body": "EmpCo gebruikt strikt noodzakelijke technische cookies (sessie, taal) en — met uw toestemming — cookies voor publiekmeting en reclame (Google Analytics en Google Ads) om onze dienst te verbeteren en onze campagnes te meten. Uw keuzes worden 13 maanden bewaard en zijn op elk moment aanpasbaar via de footer.",
    "cookie.banner.learn": "Meer weten",
    "cookie.btn.accept": "Alles accepteren",
    "cookie.btn.refuse": "Alles weigeren",
    "cookie.btn.customize": "Aanpassen",
    "cookie.btn.save": "Mijn keuzes opslaan",
    "cookie.panel.title": "Uw cookievoorkeuren",
    "cookie.panel.sub": "U kunt elke categorie in- of uitschakelen",
    "cookie.panel.legal": "Conform Verordening (EU) 2016/679 (AVG) en CNIL-besluit nr. 2020-091. Weigeren heeft geen gevolgen voor uw navigatie. Uw keuzes worden maximaal 13 maanden bewaard.",
    "cookie.cat.necessary.title": "Strikt noodzakelijke cookies",
    "cookie.cat.necessary.desc": "Onmisbaar voor de werking van de site (sessie, taal, beveiliging). Vrijgesteld van toestemming.",
    "cookie.cat.always": "Altijd actief",
    "cookie.cat.analytics.title": "Publiekmeting — Google Analytics",
    "cookie.cat.analytics.desc": "Geanonimiseerde bezoekersstatistieken om onze dienst te verbeteren. Geanonimiseerd IP, geen doorverkoop.",
    "cookie.cat.ads.title": "Reclame — Google Ads",
    "cookie.cat.ads.desc": "Meting van de prestaties van onze advertentiecampagnes en weergave van gepersonaliseerde advertenties.",
    "cookie.footer.link": "Cookie-instellingen",
    "legal.directive_cta": "EU-Richtlijn",
  },
};

const SUPPORTED = ["fr", "en", "de", "es", "it", "nl"];

function _detectLang() {
  try {
    // 1) préfixe de langue dans l'URL (/de/..., /es/...) — pages SEO localisées
    const seg = window.location.pathname.split("/")[1];
    if (seg && SUPPORTED.includes(seg)) return seg;
    // 2) query string ?lang=xx
    const qp = new URLSearchParams(window.location.search).get("lang");
    if (qp && SUPPORTED.includes(qp)) return qp;
    // 2) préférence sauvegardée
    const saved = localStorage.getItem("empco_lang");
    if (saved && SUPPORTED.includes(saved)) return saved;
    // 3) langue du navigateur (nav.languages puis nav.language)
    const langs = [
      ...((navigator.languages || [])),
      navigator.language,
    ].filter(Boolean);
    for (const l of langs) {
      const short = l.slice(0, 2).toLowerCase();
      if (SUPPORTED.includes(short)) return short;
    }
  } catch { /* fallback */ }
  return "fr";
}

const LangCtx = createContext({ lang: "fr", t: (k) => k, setLang: () => {} });

export function LangProvider({ children }) {
  const [lang, setLang] = useState(_detectLang);
  useEffect(() => {
    localStorage.setItem("empco_lang", lang);
    document.documentElement.setAttribute("lang", lang);
  }, [lang]);
  const t = (key) => dict[lang]?.[key] ?? dict.en[key] ?? dict.fr[key] ?? key;
  return <LangCtx.Provider value={{ lang, setLang, t }}>{children}</LangCtx.Provider>;
}

export const useLang = () => useContext(LangCtx);
